import { $t } from "@/utils/index.js";

export const categoryTreeListFn = function () {
  return [
    {
      id: 1,
      parent_id: 0,
      chinese_name: $t("categoryJSON.shi-shang"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list1.png",
      icon_change: "https://image.rakumart.com/images/list1_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 2,
          parent_id: 1,
          chinese_name: $t("categoryJSON.nv-shi"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: "",
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 3,
              parent_id: 2,
              chinese_name: $t("categoryJSON.wai-tao-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 4,
              parent_id: 2,
              chinese_name: $t("categoryJSON.jia-ke-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 5,
              parent_id: 2,
              chinese_name: $t("categoryJSON.tao-zhuang-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 6,
              parent_id: 2,
              chinese_name: $t("categoryJSON.t-xu-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 7,
              parent_id: 2,
              chinese_name: $t("categoryJSON.chen-shan-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 8,
              parent_id: 2,
              chinese_name: $t("categoryJSON.nv-shi-chen-shan-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 9,
              parent_id: 2,
              chinese_name: $t("categoryJSON.bei-xin-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 10,
              parent_id: 2,
              chinese_name: $t("categoryJSON.polo-shan-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 11,
              parent_id: 2,
              chinese_name: $t("categoryJSON.zhi-fu-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 12,
              parent_id: 2,
              chinese_name: $t("categoryJSON.kai-jin-shan-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 13,
              parent_id: 2,
              chinese_name: $t("categoryJSON.mao-yi-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 14,
              parent_id: 2,
              chinese_name: $t("categoryJSON.lian-yi-qun-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 15,
              parent_id: 2,
              chinese_name: $t("categoryJSON.duan-qun-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 16,
              parent_id: 2,
              chinese_name: $t("categoryJSON.niu-zi-ku-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 17,
              parent_id: 2,
              chinese_name: $t("categoryJSON.ku-zi-nv"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 18,
          parent_id: 1,
          chinese_name: $t("categoryJSON.nan-shi"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 19,
              parent_id: 18,
              chinese_name: $t("categoryJSON.wai-tao-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 20,
              parent_id: 18,
              chinese_name: $t("categoryJSON.jia-ke-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 21,
              parent_id: 18,
              chinese_name: $t("categoryJSON.tao-zhuang-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 22,
              parent_id: 18,
              chinese_name: $t("categoryJSON.bei-xin-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 23,
              parent_id: 18,
              chinese_name: $t("categoryJSON.polo-shan-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 24,
              parent_id: 18,
              chinese_name: $t("categoryJSON.zhi-fu-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 25,
              parent_id: 18,
              chinese_name: $t("categoryJSON.chen-shan-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 26,
              parent_id: 18,
              chinese_name: $t("categoryJSON.t-xu-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 27,
              parent_id: 18,
              chinese_name: $t("categoryJSON.bei-xin-nan-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 28,
              parent_id: 18,
              chinese_name: $t("categoryJSON.kai-jin-shan-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 29,
              parent_id: 18,
              chinese_name: $t("categoryJSON.mao-yi-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 30,
              parent_id: 18,
              chinese_name: $t("categoryJSON.niu-zi-ku-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 31,
              parent_id: 18,
              chinese_name: $t("categoryJSON.duan-ku-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 32,
              parent_id: 18,
              chinese_name: $t("categoryJSON.chang-ku-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 33,
              parent_id: 18,
              chinese_name: $t("categoryJSON.hei-se-zheng-zhuang-nan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 34,
          parent_id: 1,
          chinese_name: $t("categoryJSON.nei-yi-shi-nei-fu-zhuang"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 35,
              parent_id: 34,
              chinese_name: $t("categoryJSON.nei-chen"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 36,
              parent_id: 34,
              chinese_name: $t("categoryJSON.jin-shen-ku"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 37,
              parent_id: 34,
              chinese_name: $t("categoryJSON.nei-ku"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 38,
              parent_id: 34,
              chinese_name: $t("categoryJSON.quan-ji-shou"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 39,
              parent_id: 34,
              chinese_name: $t("categoryJSON.wa-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 40,
              parent_id: 34,
              chinese_name: $t("categoryJSON.yun-dong-wa"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 41,
              parent_id: 34,
              chinese_name: $t("categoryJSON.shang-wu-wa"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 42,
              parent_id: 34,
              chinese_name: $t("categoryJSON.shui-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 43,
              parent_id: 34,
              chinese_name: $t("categoryJSON.nei-bei-xin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 44,
              parent_id: 34,
              chinese_name: $t("categoryJSON.duan-ku"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 46,
              parent_id: 34,
              chinese_name: $t("categoryJSON.tuo-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 47,
              parent_id: 34,
              chinese_name: $t("categoryJSON.xiong-zhao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 48,
              parent_id: 34,
              chinese_name: $t("categoryJSON.yun-dong-wen-xiong"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 49,
              parent_id: 34,
              chinese_name: $t("categoryJSON.nei-yi-pei-shi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 50,
      parent_id: 0,
      chinese_name: $t("categoryJSON.xie-bao-pei-shi"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list2.png",
      icon_change: "https://image.rakumart.com/images/list2_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 51,
          parent_id: 50,
          chinese_name: $t("categoryJSON.xie-zi"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 52,
              parent_id: 51,
              chinese_name: $t("categoryJSON.yun-dong-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 53,
              parent_id: 51,
              chinese_name: $t("categoryJSON.liang-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 54,
              parent_id: 51,
              chinese_name: $t("categoryJSON.yu-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 55,
              parent_id: 51,
              chinese_name: $t("categoryJSON.yi-jiao-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 56,
              parent_id: 51,
              chinese_name: $t("categoryJSON.pi-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 57,
              parent_id: 51,
              chinese_name: $t("categoryJSON.gong-zuo-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 58,
              parent_id: 51,
              chinese_name: $t("categoryJSON.tuo-xie-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 59,
              parent_id: 51,
              chinese_name: $t("categoryJSON.shang-wu-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 60,
              parent_id: 51,
              chinese_name: $t("categoryJSON.xue-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 61,
          parent_id: 50,
          chinese_name: $t("categoryJSON.bei-bao-qian-bao-he-hang-li-xiang"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 62,
              parent_id: 61,
              chinese_name: $t("categoryJSON.shou-ti-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 63,
              parent_id: 61,
              chinese_name: $t("categoryJSON.dan-jian-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 64,
              parent_id: 61,
              chinese_name: $t("categoryJSON.pai-dui-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 65,
              parent_id: 61,
              chinese_name: $t("categoryJSON.bei-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 66,
              parent_id: 61,
              chinese_name: $t("categoryJSON.shang-wu-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 67,
              parent_id: 61,
              chinese_name: $t("categoryJSON.xie-kua-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 68,
              parent_id: 61,
              chinese_name: $t("categoryJSON.qian-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 69,
              parent_id: 61,
              chinese_name: $t("categoryJSON.ling-qian-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 70,
              parent_id: 61,
              chinese_name: $t("categoryJSON.qian-jia-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 71,
              parent_id: 61,
              chinese_name: $t("categoryJSON.ming-pian-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 72,
              parent_id: 61,
              chinese_name: $t("categoryJSON.yue-chi-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 73,
              parent_id: 61,
              chinese_name: $t("categoryJSON.shou-ti-xiang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 74,
          parent_id: 50,
          chinese_name: $t("categoryJSON.shi-shang-za-huo"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 75,
              parent_id: 74,
              chinese_name: $t("categoryJSON.yao-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 76,
              parent_id: 74,
              chinese_name: $t("categoryJSON.mao-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 77,
              parent_id: 74,
              chinese_name: $t("categoryJSON.shou-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 78,
              parent_id: 74,
              chinese_name: $t("categoryJSON.san"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 79,
              parent_id: 74,
              chinese_name: $t("categoryJSON.yang-san"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 80,
              parent_id: 74,
              chinese_name: $t("categoryJSON.tai-yang-jing"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 81,
              parent_id: 74,
              chinese_name: $t("categoryJSON.xiu-kou"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 82,
              parent_id: 74,
              chinese_name: $t("categoryJSON.huan-ling-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 83,
              parent_id: 74,
              chinese_name: $t("categoryJSON.ling-dai-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 84,
              parent_id: 74,
              chinese_name: $t("categoryJSON.xiong-zhen"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 85,
              parent_id: 74,
              chinese_name: $t("categoryJSON.jie-zhi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 86,
              parent_id: 74,
              chinese_name: $t("categoryJSON.diao-zhui"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 87,
              parent_id: 74,
              chinese_name: $t("categoryJSON.er-huan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 88,
              parent_id: 74,
              chinese_name: $t("categoryJSON.er-huan-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 89,
              parent_id: 74,
              chinese_name: $t("categoryJSON.er-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 90,
      parent_id: 0,
      chinese_name: $t("categoryJSON.yun-dong-hu-wai"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list3.png",
      icon_change: "https://image.rakumart.com/images/list3_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 91,
          parent_id: 90,
          chinese_name: $t("categoryJSON.hu-wai"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 92,
              parent_id: 91,
              chinese_name: $t("categoryJSON.zhang-peng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 93,
              parent_id: 91,
              chinese_name: $t("categoryJSON.ye-ying-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 94,
              parent_id: 91,
              chinese_name: $t("categoryJSON.shui-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 95,
              parent_id: 91,
              chinese_name: $t("categoryJSON.fang-chao-dian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 96,
              parent_id: 91,
              chinese_name: $t("categoryJSON.chuan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 97,
              parent_id: 91,
              chinese_name: $t("categoryJSON.deng-shan-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 98,
              parent_id: 91,
              chinese_name: $t("categoryJSON.shou-dian-tong"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 99,
              parent_id: 91,
              chinese_name: $t("categoryJSON.deng-shan-zhang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 100,
              parent_id: 91,
              chinese_name: $t("categoryJSON.peng-ren-yong-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 101,
              parent_id: 91,
              chinese_name: $t("categoryJSON.shao-kao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 102,
              parent_id: 91,
              chinese_name: $t("categoryJSON.leng-cang-xiang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 103,
              parent_id: 91,
              chinese_name: $t("categoryJSON.zhuo-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 104,
              parent_id: 91,
              chinese_name: $t("categoryJSON.diao-chuang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 105,
              parent_id: 91,
              chinese_name: $t("categoryJSON.wang-yuan-jing"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 106,
          parent_id: 90,
          chinese_name: $t("categoryJSON.yun-dong-fu-he-xie"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 107,
              parent_id: 106,
              chinese_name: $t("categoryJSON.xun-lian-fu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 108,
              parent_id: 106,
              chinese_name: $t("categoryJSON.yu-qie-fu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 109,
              parent_id: 106,
              chinese_name: $t("categoryJSON.pao-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 110,
              parent_id: 106,
              chinese_name: $t("categoryJSON.yun-dong-xie-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 111,
              parent_id: 106,
              chinese_name: $t("categoryJSON.yun-dong-fu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 112,
              parent_id: 106,
              chinese_name: $t("categoryJSON.ya-suo-shang-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 113,
              parent_id: 106,
              chinese_name: $t("categoryJSON.jin-shen-ku-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 114,
              parent_id: 106,
              chinese_name: $t("categoryJSON.chang-ku"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 115,
              parent_id: 106,
              chinese_name: $t("categoryJSON.duan-ku-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 116,
              parent_id: 106,
              chinese_name: $t("categoryJSON.mao-zi-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 117,
          parent_id: 90,
          chinese_name: $t("categoryJSON.yong-yi-he-diao-yu-gong-ju"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 118,
              parent_id: 117,
              chinese_name: $t("categoryJSON.bi-ji-ni"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 119,
              parent_id: 117,
              chinese_name: $t("categoryJSON.lian-ti-yong-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 120,
              parent_id: 117,
              chinese_name: $t("categoryJSON.er-tong-yong-zhuang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 121,
              parent_id: 117,
              chinese_name: $t("categoryJSON.xian-shui-ku"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 122,
              parent_id: 117,
              chinese_name: $t("categoryJSON.diao-yu-gan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 123,
              parent_id: 117,
              chinese_name: $t("categoryJSON.er"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 124,
              parent_id: 117,
              chinese_name: $t("categoryJSON.gou-zhen"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 125,
              parent_id: 117,
              chinese_name: $t("categoryJSON.diao-yu-bao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 126,
              parent_id: 117,
              chinese_name: $t("categoryJSON.diao-yu-pei-jian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 127,
              parent_id: 117,
              chinese_name: $t("categoryJSON.xian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 128,
              parent_id: 117,
              chinese_name: $t("categoryJSON.ha-li-si"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 129,
              parent_id: 117,
              chinese_name: $t("categoryJSON.diao-yu-leng-que-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 130,
      parent_id: 0,
      chinese_name: $t("categoryJSON.er-tong-yong-pin-wan-ju"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list4.png",
      icon_change: "https://image.rakumart.com/images/list4_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 131,
          parent_id: 130,
          chinese_name: $t("categoryJSON.wan-ju"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 132,
              parent_id: 131,
              chinese_name: $t("categoryJSON.jian-zhu-mo-kuai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 133,
              parent_id: 131,
              chinese_name: $t("categoryJSON.wu-xian-dian-kong-zhi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 134,
              parent_id: 131,
              chinese_name: $t("categoryJSON.diy-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 135,
              parent_id: 131,
              chinese_name: $t("categoryJSON.yin-le-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 136,
              parent_id: 131,
              chinese_name: $t("categoryJSON.hu-wai-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 137,
              parent_id: 131,
              chinese_name: $t("categoryJSON.yi-zhi-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 138,
              parent_id: 131,
              chinese_name: $t("categoryJSON.ying-er-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 139,
              parent_id: 131,
              chinese_name: $t("categoryJSON.shu-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 140,
              parent_id: 131,
              chinese_name: $t("categoryJSON.su-liao-mo-xing"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 141,
              parent_id: 131,
              chinese_name: $t("categoryJSON.mao-rong-gong-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 142,
              parent_id: 131,
              chinese_name: $t("categoryJSON.zhuo-shang-you-xi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 143,
              parent_id: 131,
              chinese_name: $t("categoryJSON.qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 144,
              parent_id: 131,
              chinese_name: $t("categoryJSON.hei-bai-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 145,
              parent_id: 131,
              chinese_name: $t("categoryJSON.qu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 146,
          parent_id: 130,
          chinese_name: $t("categoryJSON.nv-hai"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 147,
              parent_id: 146,
              chinese_name: $t("categoryJSON.jia-ke"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 148,
              parent_id: 146,
              chinese_name: $t("categoryJSON.qun-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 149,
              parent_id: 146,
              chinese_name: $t("categoryJSON.pai-ke"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 150,
              parent_id: 146,
              chinese_name: $t("categoryJSON.ban-ku"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 151,
              parent_id: 146,
              chinese_name: $t("categoryJSON.yu-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 152,
              parent_id: 146,
              chinese_name: $t("categoryJSON.mao-zi-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 153,
              parent_id: 146,
              chinese_name: $t("categoryJSON.tai-yang-jing-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 154,
              parent_id: 146,
              chinese_name: $t("categoryJSON.yun-dong-xie-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 155,
              parent_id: 146,
              chinese_name: $t("categoryJSON.liang-xie-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 156,
              parent_id: 146,
              chinese_name: $t("categoryJSON.yu-xie-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 157,
          parent_id: 130,
          chinese_name: $t("categoryJSON.nan-hai-er-men"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 158,
              parent_id: 157,
              chinese_name: $t("categoryJSON.wai-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 159,
              parent_id: 157,
              chinese_name: $t("categoryJSON.jia-ke-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 160,
              parent_id: 157,
              chinese_name: $t("categoryJSON.zheng-shi-de"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 161,
              parent_id: 157,
              chinese_name: $t("categoryJSON.pai-ke-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 162,
              parent_id: 157,
              chinese_name: $t("categoryJSON.ban-ku-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 163,
              parent_id: 157,
              chinese_name: $t("categoryJSON.yu-yi-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 164,
              parent_id: 157,
              chinese_name: $t("categoryJSON.mao-zi-2"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 165,
              parent_id: 157,
              chinese_name: $t("categoryJSON.tai-yang-jing-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 166,
              parent_id: 157,
              chinese_name: $t("categoryJSON.yun-dong-xie-2"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 167,
              parent_id: 157,
              chinese_name: $t("categoryJSON.liang-xie-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 168,
              parent_id: 157,
              chinese_name: $t("categoryJSON.yu-xie-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 169,
      parent_id: 0,
      chinese_name: $t("categoryJSON.chong-wu-yong-pin"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list5.png",
      icon_change: "https://image.rakumart.com/images/list5_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 170,
          parent_id: 169,
          chinese_name: $t("categoryJSON.mao-yong-pin"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 171,
              parent_id: 170,
              chinese_name: $t("categoryJSON.chuang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 172,
              parent_id: 170,
              chinese_name: $t("categoryJSON.can-ju-wan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 173,
              parent_id: 170,
              chinese_name: $t("categoryJSON.zi-dong-song-liao-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 174,
              parent_id: 170,
              chinese_name: $t("categoryJSON.chuang-sha-fa"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 175,
              parent_id: 170,
              chinese_name: $t("categoryJSON.ti-long"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 176,
              parent_id: 170,
              chinese_name: $t("categoryJSON.mao-ta"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 177,
              parent_id: 170,
              chinese_name: $t("categoryJSON.xiang-quan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 179,
              parent_id: 170,
              chinese_name: $t("categoryJSON.mao-sha-pen"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 180,
              parent_id: 170,
              chinese_name: $t("categoryJSON.yao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 181,
              parent_id: 170,
              chinese_name: $t("categoryJSON.qiu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 182,
              parent_id: 170,
              chinese_name: $t("categoryJSON.lao-shu-mao-rong-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 183,
          parent_id: 169,
          chinese_name: $t("categoryJSON.quan-yong-pin"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 184,
              parent_id: 183,
              chinese_name: $t("categoryJSON.can-ju-yu-er-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 185,
              parent_id: 183,
              chinese_name: $t("categoryJSON.zi-dong-song-liao-qi-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 186,
              parent_id: 183,
              chinese_name: $t("categoryJSON.die-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 187,
              parent_id: 183,
              chinese_name: $t("categoryJSON.shui-rong-qi-shui-ping"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 188,
              parent_id: 183,
              chinese_name: $t("categoryJSON.shua-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 189,
              parent_id: 183,
              chinese_name: $t("categoryJSON.mu-yu-yong-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 190,
              parent_id: 183,
              chinese_name: $t("categoryJSON.xiang-quan-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 191,
              parent_id: 183,
              chinese_name: $t("categoryJSON.qian-gou-sheng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 192,
              parent_id: 183,
              chinese_name: $t("categoryJSON.xie-dai-rong-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 193,
              parent_id: 183,
              chinese_name: $t("categoryJSON.long"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 194,
              parent_id: 183,
              chinese_name: $t("categoryJSON.gou-wo"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 195,
              parent_id: 183,
              chinese_name: $t("categoryJSON.chuang-dian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 196,
              parent_id: 183,
              chinese_name: $t("categoryJSON.qiu-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 197,
              parent_id: 183,
              chinese_name: $t("categoryJSON.tou-zhi-wan-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 198,
              parent_id: 183,
              chinese_name: $t("categoryJSON.fu-zhuang-yu-shi-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 199,
      parent_id: 0,
      chinese_name: $t("categoryJSON.shi-nei-yong-pin"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list6.png",
      icon_change: "https://image.rakumart.com/images/list6_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 200,
          parent_id: 199,
          chinese_name: $t("categoryJSON.shou-na-yong-pin"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 201,
              parent_id: 200,
              chinese_name: $t("categoryJSON.lan-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 202,
              parent_id: 200,
              chinese_name: $t("categoryJSON.ya-suo-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 203,
              parent_id: 200,
              chinese_name: $t("categoryJSON.za-zhi-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 204,
              parent_id: 200,
              chinese_name: $t("categoryJSON.yao-kong-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 205,
              parent_id: 200,
              chinese_name: $t("categoryJSON.gou"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 206,
              parent_id: 200,
              chinese_name: $t("categoryJSON.chu-wu-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 207,
              parent_id: 200,
              chinese_name: $t("categoryJSON.bi-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 209,
          parent_id: 199,
          chinese_name: $t("categoryJSON.za-huo"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 210,
              parent_id: 209,
              chinese_name: $t("categoryJSON.gua-zhong"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 211,
              parent_id: 209,
              chinese_name: $t("categoryJSON.la-ji-tong"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 212,
              parent_id: 209,
              chinese_name: $t("categoryJSON.qiang-tie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 213,
              parent_id: 209,
              chinese_name: $t("categoryJSON.xie-ba-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 214,
              parent_id: 209,
              chinese_name: $t("categoryJSON.zhi-men-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 215,
              parent_id: 209,
              chinese_name: $t("categoryJSON.zhu-tai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 216,
              parent_id: 209,
              chinese_name: $t("categoryJSON.yan-hui-gang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 217,
              parent_id: 209,
              chinese_name: $t("categoryJSON.feng-shui-wu-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 218,
              parent_id: 209,
              chinese_name: $t("categoryJSON.chuang-mo"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 219,
              parent_id: 209,
              chinese_name: $t("categoryJSON.bian-li-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 220,
      parent_id: 0,
      chinese_name: $t("categoryJSON.ban-gong-yong-pin"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list7.png",
      icon_change: "https://image.rakumart.com/images/list7_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 221,
          parent_id: 220,
          chinese_name: $t("categoryJSON.ban-gong-yong-pin-0"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 222,
              parent_id: 221,
              chinese_name: $t("categoryJSON.dao-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 223,
              parent_id: 221,
              chinese_name: $t("categoryJSON.jian-dao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 224,
              parent_id: 221,
              chinese_name: $t("categoryJSON.jiao-shui"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 225,
              parent_id: 221,
              chinese_name: $t("categoryJSON.ding-shu-ji"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 226,
              parent_id: 221,
              chinese_name: $t("categoryJSON.jiao-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 227,
              parent_id: 221,
              chinese_name: $t("categoryJSON.jia-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 228,
              parent_id: 221,
              chinese_name: $t("categoryJSON.zheng-jian-pai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 229,
              parent_id: 221,
              chinese_name: $t("categoryJSON.zheng-shu-kuang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 230,
              parent_id: 221,
              chinese_name: $t("categoryJSON.wen-jian-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 231,
              parent_id: 221,
              chinese_name: $t("categoryJSON.yuan-zhu-bi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 232,
              parent_id: 221,
              chinese_name: $t("categoryJSON.gang-bi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 233,
              parent_id: 221,
              chinese_name: $t("categoryJSON.bai-ban"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 234,
          parent_id: 220,
          chinese_name: $t("categoryJSON.ban-gong-yong-zhi"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 235,
              parent_id: 234,
              chinese_name: $t("categoryJSON.fu-yin-zhi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 236,
              parent_id: 234,
              chinese_name: $t("categoryJSON.ji-guang-da-yin-zhi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 237,
              parent_id: 234,
              chinese_name: $t("categoryJSON.yin-shua-yong-cai-zhi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 238,
              parent_id: 234,
              chinese_name: $t("categoryJSON.hui-tu-zhi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 239,
              parent_id: 234,
              chinese_name: $t("categoryJSON.xin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 240,
              parent_id: 234,
              chinese_name: $t("categoryJSON.bian-li-tie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 241,
              parent_id: 234,
              chinese_name: $t("categoryJSON.huo-ye"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 242,
              parent_id: 234,
              chinese_name: $t("categoryJSON.ji-shi-ben"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 243,
      parent_id: 0,
      chinese_name: $t("categoryJSON.qi-che-he-zi-hang-che"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list8.png",
      icon_change: "https://image.rakumart.com/images/list8_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 244,
          parent_id: 243,
          chinese_name: $t("categoryJSON.qi-che-pei-jian"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: "",
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 245,
              parent_id: 244,
              chinese_name: $t("categoryJSON.hang-che-ji-lu-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 246,
              parent_id: 244,
              chinese_name: $t("categoryJSON.hou-zhi-she-xiang-tou-ji-shen"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 250,
              parent_id: 244,
              chinese_name: $t("categoryJSON.zuo-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 251,
              parent_id: 244,
              chinese_name: $t("categoryJSON.zuo-dian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 252,
              parent_id: 244,
              chinese_name: $t("categoryJSON.tie-zhi-tie-hua-yin-zhang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 253,
              parent_id: 244,
              chinese_name: $t("categoryJSON.fang-xiang-pan-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 254,
              parent_id: 244,
              chinese_name: $t("categoryJSON.kong-qi-jing-hua-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 255,
              parent_id: 244,
              chinese_name: $t("categoryJSON.yan-hui-gang-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 256,
              parent_id: 244,
              chinese_name: $t("categoryJSON.an-quan-dai-yong-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 257,
              parent_id: 244,
              chinese_name: $t("categoryJSON.ying-er-er-tong-zuo-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 258,
              parent_id: 244,
              chinese_name: $t("categoryJSON.kong-tiao-lv-qing-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 259,
          parent_id: 243,
          chinese_name: $t("categoryJSON.qi-che-yong-pin"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 260,
              parent_id: 259,
              chinese_name: $t("categoryJSON.che-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: "",
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 261,
              parent_id: 259,
              chinese_name: $t("categoryJSON.cha-che-ling-jian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 262,
              parent_id: 259,
              chinese_name: $t("categoryJSON.wai-shi-he-hang-kong-bu-jian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 263,
              parent_id: 259,
              chinese_name: $t("categoryJSON.jia-qiang-jian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 264,
              parent_id: 259,
              chinese_name: $t("categoryJSON.bao-yang-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 265,
              parent_id: 259,
              chinese_name: $t("categoryJSON.qi-che-wei-xiu-gong-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 266,
              parent_id: 259,
              chinese_name: $t("categoryJSON.kong-tiao-wei-xiu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 267,
              parent_id: 259,
              chinese_name: $t("categoryJSON.che-ku-yong-pin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 268,
              parent_id: 259,
              chinese_name: $t("categoryJSON.wu-ding-zai-ti"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 269,
              parent_id: 259,
              chinese_name: $t("categoryJSON.hou-zhi-zai-ti"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 270,
              parent_id: 259,
              chinese_name: $t("categoryJSON.lun-tai-jia-gai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 271,
          parent_id: 243,
          chinese_name: $t("categoryJSON.zi-hang-che-yong-pin"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 272,
              parent_id: 271,
              chinese_name: $t("categoryJSON.zheng-ge-lian"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 273,
              parent_id: 271,
              chinese_name: $t("categoryJSON.yi-ban"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 274,
              parent_id: 271,
              chinese_name: $t("categoryJSON.jia-ke-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 275,
              parent_id: 271,
              chinese_name: $t("categoryJSON.shou-tao-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 276,
              parent_id: 271,
              chinese_name: $t("categoryJSON.xue-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 277,
              parent_id: 271,
              chinese_name: $t("categoryJSON.yu-yi-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 278,
              parent_id: 271,
              chinese_name: $t("categoryJSON.bao-hu-zhe"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 279,
              parent_id: 271,
              chinese_name: $t("categoryJSON.sai-che-fu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 280,
              parent_id: 271,
              chinese_name: $t("categoryJSON.yan-jing"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 281,
              parent_id: 271,
              chinese_name: $t("categoryJSON.yin-liao-jia"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 282,
              parent_id: 271,
              chinese_name: $t("categoryJSON.tou-kui-suo"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 283,
              parent_id: 271,
              chinese_name: $t("categoryJSON.zi-hang-che-suo"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 284,
              parent_id: 271,
              chinese_name: $t("categoryJSON.che-shen-zhao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 285,
              parent_id: 271,
              chinese_name: $t("categoryJSON.zuo-tao-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 286,
              parent_id: 271,
              chinese_name: $t("categoryJSON.mo-tuo-che-tie-zhi-he-tie-hua"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 287,
      parent_id: 0,
      chinese_name: $t("categoryJSON.jia-ju-qin-shi-yong-pin"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list9.png",
      icon_change: "https://image.rakumart.com/images/list9_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 288,
          parent_id: 287,
          chinese_name: $t("categoryJSON.jia-ju"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 289,
              parent_id: 288,
              chinese_name: $t("categoryJSON.zhuo-zi-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 290,
              parent_id: 288,
              chinese_name: $t("categoryJSON.can-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 291,
              parent_id: 288,
              chinese_name: $t("categoryJSON.zhuo-zi-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 292,
              parent_id: 288,
              chinese_name: $t("categoryJSON.zuo-yi-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 293,
              parent_id: 288,
              chinese_name: $t("categoryJSON.yi-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 294,
              parent_id: 288,
              chinese_name: $t("categoryJSON.sha-fa"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 295,
              parent_id: 288,
              chinese_name: $t("categoryJSON.jiao-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 296,
              parent_id: 288,
              chinese_name: $t("categoryJSON.sha-fa-chuang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 297,
              parent_id: 288,
              chinese_name: $t("categoryJSON.chuang-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 298,
              parent_id: 288,
              chinese_name: $t("categoryJSON.chuang-tou-gui"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 299,
              parent_id: 288,
              chinese_name: $t("categoryJSON.chuang-wei-shi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 300,
              parent_id: 288,
              chinese_name: $t("categoryJSON.shu-zhuang-tai-shu-zhuang-tai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 301,
              parent_id: 288,
              chinese_name: $t("categoryJSON.fen-qu-ping-mu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 302,
          parent_id: 287,
          chinese_name: $t("categoryJSON.qin-shi-yong-pin"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 303,
              parent_id: 302,
              chinese_name: $t("categoryJSON.zhen-tou-bao-zhen"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 304,
              parent_id: 302,
              chinese_name: $t("categoryJSON.bei-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 305,
              parent_id: 302,
              chinese_name: $t("categoryJSON.chuang-dian-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 306,
              parent_id: 302,
              chinese_name: $t("categoryJSON.chuang-dian-1"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 307,
              parent_id: 302,
              chinese_name: $t("categoryJSON.bei-ru"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 308,
              parent_id: 302,
              chinese_name: $t("categoryJSON.mian-bei"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 309,
              parent_id: 302,
              chinese_name: $t("categoryJSON.chuang-shang-yong-pin-chuang-dan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 310,
              parent_id: 302,
              chinese_name: $t("categoryJSON.tan-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 311,
              parent_id: 302,
              chinese_name: $t("categoryJSON.tan-zi-he-juan-tong-chuan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 312,
              parent_id: 302,
              chinese_name: $t("categoryJSON.gai-tan-ban-tan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 313,
              parent_id: 302,
              chinese_name: $t("categoryJSON.mao-jin-tan-sha-tan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 314,
      parent_id: 0,
      chinese_name: $t("categoryJSON.shou-ji-dian-zi-chan-pin"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list10.png",
      icon_change: "https://image.rakumart.com/images/list10_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 315,
          parent_id: 314,
          chinese_name: $t("categoryJSON.she-xiang-tou"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 316,
              parent_id: 315,
              chinese_name: $t("categoryJSON.wai-jie-ying-pan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 317,
              parent_id: 315,
              chinese_name: $t(
                "categoryJSON.usb-cun-chu-qi-shan-cun-qu-dong-qi"
              ),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 318,
              parent_id: 315,
              chinese_name: $t("categoryJSON.wai-bu-du-ka-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 319,
              parent_id: 315,
              chinese_name: $t("categoryJSON.tou-ying-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 320,
              parent_id: 315,
              chinese_name: $t("categoryJSON.zhuan-huan-shi-pei-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 321,
              parent_id: 315,
              chinese_name: $t("categoryJSON.dian-lan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 322,
              parent_id: 315,
              chinese_name: $t("categoryJSON.kai-guan-ji"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 323,
              parent_id: 315,
              chinese_name: $t("categoryJSON.pc-bao-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 324,
              parent_id: 315,
              chinese_name: $t("categoryJSON.cun-chu-ka"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 325,
              parent_id: 315,
              chinese_name: $t("categoryJSON.you-xi-jian-pan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 326,
              parent_id: 315,
              chinese_name: $t("categoryJSON.jian-pan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 327,
              parent_id: 315,
              chinese_name: $t("categoryJSON.shu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 328,
              parent_id: 315,
              chinese_name: $t("categoryJSON.you-xi-shu-biao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 329,
              parent_id: 315,
              chinese_name: $t("categoryJSON.you-xi-shou-bing"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 330,
              parent_id: 315,
              chinese_name: $t("categoryJSON.she-xiang-tou-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 331,
          parent_id: 314,
          chinese_name: $t("categoryJSON.zhi-neng-shou-biao"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 332,
              parent_id: 331,
              chinese_name: $t("categoryJSON.yi-dong-shen-ti"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 333,
              parent_id: 331,
              chinese_name: $t("categoryJSON.an-zi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 334,
              parent_id: 331,
              chinese_name: $t("categoryJSON.fu-gai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 335,
              parent_id: 331,
              chinese_name: $t("categoryJSON.dian-chi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 336,
              parent_id: 331,
              chinese_name: $t("categoryJSON.dian-lan-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 337,
              parent_id: 331,
              chinese_name: $t("categoryJSON.zhan-li"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 338,
              parent_id: 331,
              chinese_name: $t("categoryJSON.ye-jing-bao-hu-mo"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 339,
              parent_id: 331,
              chinese_name: $t("categoryJSON.er-ji-lan-ya"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 340,
              parent_id: 331,
              chinese_name: $t("categoryJSON.er-ji"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 341,
              parent_id: 331,
              chinese_name: $t("categoryJSON.zi-pai-gan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 342,
              parent_id: 331,
              chinese_name: $t("categoryJSON.zhi-neng-shou-biao-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 343,
          parent_id: 314,
          chinese_name: $t("categoryJSON.jian-kong-she-xiang-tou"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 344,
              parent_id: 343,
              chinese_name: $t("categoryJSON.kong-qi-jing-hua-qi-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 345,
              parent_id: 343,
              chinese_name: $t("categoryJSON.chu-shi-ji"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 346,
              parent_id: 343,
              chinese_name: $t("categoryJSON.jia-shi-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 347,
              parent_id: 343,
              chinese_name: $t("categoryJSON.re-di-tan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 348,
              parent_id: 343,
              chinese_name: $t("categoryJSON.zhi-jia-hong-gan-ji"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 349,
              parent_id: 343,
              chinese_name: $t("categoryJSON.an-mo-yi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 350,
              parent_id: 343,
              chinese_name: $t("categoryJSON.an-mo-yi-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 351,
              parent_id: 343,
              chinese_name: $t("categoryJSON.bing-xiang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 352,
              parent_id: 343,
              chinese_name: $t("categoryJSON.jia-ting-ying-yuan-xi-tong"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 353,
              parent_id: 343,
              chinese_name: $t("categoryJSON.wu-ren-ji"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 354,
              parent_id: 343,
              chinese_name: $t("categoryJSON.yang-sheng-qi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 355,
              parent_id: 343,
              chinese_name: $t("categoryJSON.jian-kong-she-xiang-tou-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 356,
      parent_id: 0,
      chinese_name: $t("categoryJSON.zhao-ming-she-bei"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list11.png",
      icon_change: "https://image.rakumart.com/images/list11_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 357,
          parent_id: 356,
          chinese_name: $t("categoryJSON.led-ri-guang-deng"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 358,
              parent_id: 357,
              chinese_name: $t("categoryJSON.la-di-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 359,
              parent_id: 357,
              chinese_name: $t("categoryJSON.tai-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 360,
              parent_id: 357,
              chinese_name: $t("categoryJSON.zhao-ming-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 361,
              parent_id: 357,
              chinese_name: $t("categoryJSON.xiang-xun-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 362,
              parent_id: 357,
              chinese_name: $t("categoryJSON.zhu-guang"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 363,
              parent_id: 357,
              chinese_name: $t("categoryJSON.deng-zhao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 364,
              parent_id: 357,
              chinese_name: $t("categoryJSON.ju-guang-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 365,
              parent_id: 357,
              chinese_name: $t("categoryJSON.guan-dao-dao-gui-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 366,
              parent_id: 357,
              chinese_name: $t("categoryJSON.gan-ying-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 367,
              parent_id: 357,
              chinese_name: $t("categoryJSON.ting-yuan-deng"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 368,
              parent_id: 357,
              chinese_name: $t("categoryJSON.lan"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 369,
              parent_id: 357,
              chinese_name: $t("categoryJSON.led-deng-pao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 370,
              parent_id: 357,
              chinese_name: $t("categoryJSON.led-ri-guang-deng-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
    {
      id: 371,
      parent_id: 0,
      chinese_name: $t("categoryJSON.gong-ju-xian-chang-yong-pin"),

      sort: 0,
      icon_default: "https://image.rakumart.com/images/list12.png",
      icon_change: "https://image.rakumart.com/images/list12_b.png",
      icon_app: null,
      type: 1,
      remark: "",
      list_banner: "",
      default_back_color: "",
      trigger_back_color: "",

      relation_cate_id: 0,
      relation_hot_cate: null,
      childs: [
        {
          id: 372,
          parent_id: 371,
          chinese_name: $t("categoryJSON.yan-mo-gong-ju"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 373,
              parent_id: 372,
              chinese_name: $t("categoryJSON.dian-dong-gong-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 374,
              parent_id: 372,
              chinese_name: $t("categoryJSON.shou-dong-gong-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 375,
              parent_id: 372,
              chinese_name: $t("categoryJSON.qi-dong-gong-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 376,
              parent_id: 372,
              chinese_name: $t("categoryJSON.yan-mo-gong-ju-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
        {
          id: 377,
          parent_id: 371,
          chinese_name: $t("categoryJSON.xin-hao-deng"),

          sort: 0,
          icon_default: "",
          icon_change: "",
          icon_app: null,
          type: 1,
          remark: "",
          list_banner: "",
          default_back_color: "",
          trigger_back_color: "",

          relation_cate_id: 0,
          relation_hot_cate: null,
          childs: [
            {
              id: 378,
              parent_id: 377,
              chinese_name: $t("categoryJSON.lao-bao-xie"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 379,
              parent_id: 377,
              chinese_name: $t("categoryJSON.ye-zhan-tou-kui"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 380,
              parent_id: 377,
              chinese_name: $t("categoryJSON.ge-yin"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 381,
              parent_id: 377,
              chinese_name: $t("categoryJSON.an-quan-dai"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 382,
              parent_id: 377,
              chinese_name: $t("categoryJSON.gong-zuo-hu-mu-jing"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 383,
              parent_id: 377,
              chinese_name: $t("categoryJSON.gong-zuo-shou-tao"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 384,
              parent_id: 377,
              chinese_name: $t("categoryJSON.gong-zuo-mian-ju"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 385,
              parent_id: 377,
              chinese_name: $t("categoryJSON.gong-zuo-fu"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 386,
              parent_id: 377,
              chinese_name: $t("categoryJSON.an-quan-biao-shi"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 387,
              parent_id: 377,
              chinese_name: $t("categoryJSON.se-zhui"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
            {
              id: 388,
              parent_id: 377,
              chinese_name: $t("categoryJSON.xin-hao-deng-0"),

              sort: 0,
              icon_default: "",
              icon_change: "",
              icon_app: null,
              type: 1,
              remark: "",
              list_banner: "",
              default_back_color: "",
              trigger_back_color: "",

              relation_cate_id: 0,
              relation_hot_cate: null,
              childs: [],
            },
          ],
        },
      ],
    },
  ];
};
export const categorySearchTreeListFn = function () {
  return [
    {
      id: 484,
      chinese_name: $t("categoryJSON.shi-pin"),

      relation_cate_id: 54,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.xiang-lian"),
          seKeywordTranslation: $t("categoryJSON.nekkuresu"),
        },
        {
          seKeyword: $t("categoryJSON.fa-jia"),
          seKeywordTranslation: $t("categoryJSON.heapin"),
        },
        {
          seKeyword: $t("categoryJSON.jie-zhi-0"),
          seKeywordTranslation: $t("categoryJSON.ringu"),
        },
        {
          seKeyword: $t("categoryJSON.shou-lian"),
          seKeywordTranslation: $t("categoryJSON.buresuretto"),
        },
        {
          seKeyword: $t("categoryJSON.er-ding"),
          seKeywordTranslation: $t("categoryJSON.piasu"),
        },
        {
          seKeyword: $t("categoryJSON.shou-biao"),
          seKeywordTranslation: $t("categoryJSON.wan-shi-ji"),
        },
        {
          seKeyword: $t("categoryJSON.mao-zi-3"),
          seKeywordTranslation: $t("categoryJSON.hatto"),
        },
        {
          seKeyword: $t("categoryJSON.er-huan-1"),
          seKeywordTranslation: $t("categoryJSON.iyaringu"),
        },
        {
          seKeyword: $t("categoryJSON.shi-pin-0"),
          seKeywordTranslation: $t("categoryJSON.akusesar"),
        },
        {
          seKeyword: $t("categoryJSON.zhua-jia"),
          seKeywordTranslation: $t("categoryJSON.gurippu"),
        },
      ],
    },
    {
      id: 485,
      chinese_name: $t("categoryJSON.shou-ji"),

      relation_cate_id: 50911,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.shou-ji-ke"),
          seKeywordTranslation: $t("categoryJSON.ksu"),
        },
        {
          seKeyword: $t("categoryJSON.er-ji-0"),
          seKeywordTranslation: $t("categoryJSON.iyafon"),
        },
        {
          seKeyword: $t("categoryJSON.lan-ya-er-ji"),
          seKeywordTranslation: $t("categoryJSON.bluetoothiyafon"),
        },
        {
          seKeyword: $t("categoryJSON.chong-dian-bao"),
          seKeywordTranslation: $t("categoryJSON.chong-dian-qi"),
        },
        {
          seKeyword: $t("categoryJSON.shou-ji-zhi-jia"),
          seKeywordTranslation: $t("categoryJSON.horud"),
        },
        {
          seKeyword: $t("categoryJSON.ping-guo-shou-ji-ke"),
          seKeywordTranslation: $t("categoryJSON.appurunoksu"),
        },
        {
          seKeyword: $t("categoryJSON.lan-ya-er-ji-wu-xian"),
          seKeywordTranslation: $t("categoryJSON.bluetoothiyahon"),
        },
        {
          seKeyword: $t("categoryJSON.lan-ya-er-ji-chao-chang-xu-hang"),
          seKeywordTranslation: $t("categoryJSON.bluetoothiyahonnosa"),
        },
        {
          seKeyword: $t("categoryJSON.shu-ju-xian"),
          seKeywordTranslation: $t("categoryJSON.dtakburu"),
        },
        {
          seKeyword: $t("categoryJSON.er-ji-lan-ya-bu-ru-er"),
          seKeywordTranslation: $t("categoryJSON.iyahonnobluetoothganiranai"),
        },
      ],
    },
    {
      id: 487,
      chinese_name: $t("categoryJSON.fu-shi"),

      relation_cate_id: 122380006,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.kou-shui-jin"),
          seKeywordTranslation: $t("categoryJSON.yodaretaoru"),
        },
        {
          seKeyword: $t("categoryJSON.ge-niao-dian"),
          seKeywordTranslation: $t("categoryJSON.ripaddo"),
        },
        {
          seKeyword: $t("categoryJSON.kou-shui-jin-ying-eralei-quan-mian"),
          seKeywordTranslation: $t("categoryJSON.yodaretaorubebkurasuakotton"),
        },
        {
          seKeyword: $t("categoryJSON.an-dan-shui-dai"),
          seKeywordTranslation: $t("categoryJSON.an-dan-qin-dai"),
        },
        {
          seKeyword: $t("categoryJSON.bao-bei"),
          seKeywordTranslation: $t("categoryJSON.kaban"),
        },
        {
          seKeyword: $t(
            "categoryJSON.wen-feng-qu-he-er-te-yi-zhi-yi-jing-xiao-bu"
          ),
          seKeywordTranslation: $t("categoryJSON.nononono"),
        },
        {
          seKeyword: $t("categoryJSON.han-jin"),
          seKeywordTranslation: $t("categoryJSON.taoru"),
        },
        {
          seKeyword: $t("categoryJSON.ying-er-yong-pin"),
          seKeywordTranslation: $t("categoryJSON.beb"),
        },
        {
          seKeyword: $t("categoryJSON.an-dan"),
          seKeywordTranslation: $t("categoryJSON.an-dan-0"),
        },
        {
          seKeyword: $t("categoryJSON.ying-er-shui-dai"),
          seKeywordTranslation: $t("categoryJSON.beb-0"),
        },
      ],
    },
    {
      id: 488,
      chinese_name: $t("categoryJSON.chong-wu"),

      relation_cate_id: 201305503,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.chong-wu-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.petto"),
        },
        {
          seKeyword: $t("categoryJSON.gou-gou-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.no"),
        },
        {
          seKeyword: $t("categoryJSON.chong-wu-yi-fu-gou-gou-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.petto-0"),
        },
        {
          seKeyword: $t("categoryJSON.gou-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.quan-fu"),
        },
        {
          seKeyword: $t("categoryJSON.mao-mi-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.mao-fu"),
        },
        {
          seKeyword: $t("categoryJSON.chong-wu-xiang-quan"),
          seKeywordTranslation: $t("categoryJSON.pettono"),
        },
        {
          seKeyword: $t("categoryJSON.chong-wu-xin-nian-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.pettono-0"),
        },
        {
          seKeyword: $t("categoryJSON.mao-yi-fu"),
          seKeywordTranslation: $t("categoryJSON.mao-fu-0"),
        },
        {
          seKeyword: $t("categoryJSON.gou-xiang-quan"),
          seKeywordTranslation: $t("categoryJSON.no-0"),
        },
        {
          seKeyword: $t("categoryJSON.yi-li-suo-bai-quan"),
          seKeywordTranslation: $t("categoryJSON.erizabesuskuru"),
        },
      ],
    },
    {
      id: 489,
      chinese_name: $t("categoryJSON.yong-yi"),

      relation_cate_id: 122110001,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.er-tong-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.kizzu"),
        },
        {
          seKeyword: $t("categoryJSON.yong-yi-er-tong"),
          seKeywordTranslation: $t("categoryJSON.shui-zhuo-zi-gong"),
        },
        {
          seKeyword: $t("categoryJSON.nv-tong-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.nv-er-shui-zhuo"),
        },
        {
          seKeyword: $t("categoryJSON.nan-tong-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.bizu"),
        },
        {
          seKeyword: $t("categoryJSON.bao-bao-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.beb-1"),
        },
        {
          seKeyword: $t("categoryJSON.er-tong-yong-ku"),
          seKeywordTranslation: $t("categoryJSON.pantsu"),
        },
        {
          seKeyword: $t("categoryJSON.er-tong-yong-yi-36-sui"),
          seKeywordTranslation: $t(
            "categoryJSON.zi-gong-yong-shui-zhuo-3-6-sui"
          ),
        },
        {
          seKeyword: $t("categoryJSON.yong-yi-nv-tong"),
          seKeywordTranslation: $t("categoryJSON.gru"),
        },
        {
          seKeyword: $t("categoryJSON.ying-er-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.beb-2"),
        },
        {
          seKeyword: $t("categoryJSON.mei-ren-yu-fu-zhuang-er-tong"),
          seKeywordTranslation: $t("categoryJSON.mmeidokosuchmu"),
        },
      ],
    },
    {
      id: 491,
      chinese_name: $t("categoryJSON.yong-yi-0"),

      relation_cate_id: 122108001,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.bi-ji-ni-0"),
          seKeywordTranslation: $t("categoryJSON.bikini"),
        },
        {
          seKeyword: $t("categoryJSON.liang-jian-tao-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.2setto"),
        },
        {
          seKeyword: $t("categoryJSON.bi-ji-ni-xing-gan-la-mei-zhuang"),
          seKeywordTranslation: $t("categoryJSON.bikinisekushgyaru"),
        },
        {
          seKeyword: $t("categoryJSON.yong-yi-bi-ji-ni"),
          seKeywordTranslation: $t("categoryJSON.bikini-0"),
        },
        {
          seKeyword: $t("categoryJSON.nv-shi-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.redsu"),
        },
        {
          seKeyword: "bikini",
          seKeywordTranslation: $t("categoryJSON.bikini-1"),
        },
        {
          seKeyword: $t("categoryJSON.bi-ji-ni-yong-yi"),
          seKeywordTranslation: $t("categoryJSON.bikini-2"),
        },
        {
          seKeyword: $t("categoryJSON.xing-gan-bi-ji-ni"),
          seKeywordTranslation: $t("categoryJSON.sekushbikini"),
        },
        {
          seKeyword: $t("categoryJSON.ti-yong-yi-di-yao-bao"),
          seKeywordTranslation: $t("categoryJSON.nohagaidesu"),
        },
        {
          seKeyword: $t(
            "categoryJSON.xing-gan-bi-ji-ni-yong-zhuang-wai-mao-kua-jing"
          ),
          seKeywordTranslation: $t("categoryJSON.sekushbikinikurosubd"),
        },
      ],
    },
    {
      id: 492,
      chinese_name: $t("categoryJSON.zhang-peng-0"),

      relation_cate_id: 201901404,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.zhang-peng-1"),
          seKeywordTranslation: $t("categoryJSON.tento"),
        },
        {
          seKeyword: $t("categoryJSON.zhang-peng-lou-ying-zhang-peng"),
          seKeywordTranslation: $t("categoryJSON.tentokyanputento"),
        },
        {
          seKeyword: $t("categoryJSON.hu-wai-zhang-peng"),
          seKeywordTranslation: $t("categoryJSON.autodoatento"),
        },
        {
          seKeyword: $t("categoryJSON.lou-ying-zhang-peng"),
          seKeywordTranslation: $t("categoryJSON.kyanputento"),
        },
        {
          seKeyword: $t("categoryJSON.chong-qi-zhang-peng"),
          seKeywordTranslation: $t("categoryJSON.ritento"),
        },
        {
          seKeyword: $t("categoryJSON.ning-bo-ye-ying-zhuang-bei"),
          seKeywordTranslation: $t("categoryJSON.kyanpu"),
        },
        {
          seKeyword: $t("categoryJSON.hu-wai-lou-ying-zhang-peng"),
          seKeywordTranslation: $t("categoryJSON.kyanputento-0"),
        },
        {
          seKeyword: $t(
            "categoryJSON.zhang-peng-bian-xie-shi-zhe-die-quan-zi-dong"
          ),
          seKeywordTranslation: $t("categoryJSON.tentoptabururitatami"),
        },
        {
          seKeyword: $t("categoryJSON.zi-jia-zhuang-bei"),
          seKeywordTranslation: $t("categoryJSON.desuru"),
        },
        {
          seKeyword: $t("categoryJSON.zhang-peng-gong-yuan-zhang-peng"),
          seKeywordTranslation: $t("categoryJSON.tentotento"),
        },
      ],
    },
    {
      id: 493,
      chinese_name: $t("categoryJSON.chu-fang"),

      relation_cate_id: 10301,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.shui-shao"),
          seKeywordTranslation: $t("categoryJSON.saji"),
        },
        {
          seKeyword: $t("categoryJSON.shui-piao-chu-fang-yong"),
          seKeywordTranslation: $t("categoryJSON.kitchin"),
        },
        {
          seKeyword: $t("categoryJSON.shui-piao"),
          seKeywordTranslation: $t("categoryJSON.gau"),
        },
        {
          seKeyword: $t("categoryJSON.shui-yao-zi"),
          seKeywordTranslation: $t("categoryJSON.shibuki"),
        },
        {
          seKeyword: $t("categoryJSON.shui-shao-shui-piao-da-hao"),
          seKeywordTranslation: $t("categoryJSON.sajinonokiisaizu"),
        },
        {
          seKeyword: $t("categoryJSON.shui-piao-su-liao-da-hao"),
          seKeywordTranslation: $t("categoryJSON.purasuchikkusaizu"),
        },
        {
          seKeyword: $t("categoryJSON.shui-yao"),
          seKeywordTranslation: $t("categoryJSON.sukui"),
        },
        {
          seKeyword: $t("categoryJSON.su-liao-shui-piao"),
          seKeywordTranslation: $t("categoryJSON.purasuchikkusukpu"),
        },
        {
          seKeyword: $t("categoryJSON.yao-zi"),
          seKeywordTranslation: $t("categoryJSON.zi"),
        },
        {
          seKeyword: $t("categoryJSON.chou-you-yan-ji-dian-you-zhi"),
          seKeywordTranslation: $t("categoryJSON.niwoku"),
        },
      ],
    },
    {
      id: 494,
      chinese_name: $t("categoryJSON.lian-yi-qun"),

      relation_cate_id: 1031910,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.lian-yi-qun-0"),
          seKeywordTranslation: $t("categoryJSON.wanpsu"),
        },
        {
          seKeyword: $t("categoryJSON.qun-zi-0"),
          seKeywordTranslation: $t("categoryJSON.sukto"),
        },
        {
          seKeyword: $t("categoryJSON.guang-zhou-shi-san-hang"),
          seKeywordTranslation: $t("categoryJSON.guang-zhou-shi-san-hang-0"),
        },
        {
          seKeyword: $t("categoryJSON.hang-zhou-si-ji-qing"),
          seKeywordTranslation: $t("categoryJSON.hang-zhou-si-ji-qing-0"),
        },
        {
          seKeyword: $t("categoryJSON.diao-dai-qun"),
          seKeywordTranslation: $t("categoryJSON.sasupendsukto"),
        },
      ],
    },
    {
      id: 496,
      chinese_name: $t("categoryJSON.er-ji-1"),

      relation_cate_id: 10333,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.er-ji-you-xian-ru-er-yin-zhi-hao"),
          seKeywordTranslation: $t("categoryJSON.iyahonhadenirugaiidesu"),
        },
        {
          seKeyword: $t("categoryJSON.you-xian-er-ji"),
          seKeywordTranslation: $t("categoryJSON.iyahon"),
        },
        {
          seKeyword: $t("categoryJSON.er-ji-you-xian"),
          seKeywordTranslation: $t("categoryJSON.iyahon-0"),
        },
        {
          seKeyword: $t("categoryJSON.er-ji-typec-jie-kou"),
          seKeywordTranslation: $t("categoryJSON.iyahontype-cintfeisu"),
        },
        {
          seKeyword: $t("categoryJSON.dian-jing-er-ji"),
          seKeywordTranslation: $t("categoryJSON.noiyahon"),
        },
        {
          seKeyword: $t("categoryJSON.er-ji-you-xian-ru-er-shi"),
          seKeywordTranslation: $t("categoryJSON.iyahon-1"),
        },
        {
          seKeyword: $t("categoryJSON.dian-nao-er-ji"),
          seKeywordTranslation: $t("categoryJSON.pasokonheddosetto"),
        },
        {
          seKeyword: $t("categoryJSON.you-xi-er-ji"),
          seKeywordTranslation: $t("categoryJSON.gmuheddofon"),
        },
        {
          seKeyword: "ikf",
          seKeywordTranslation: $t("categoryJSON.ikf"),
        },
        {
          seKeyword: $t("categoryJSON.jian-ting-er-ji"),
          seKeywordTranslation: $t("categoryJSON.iyahonwosuru"),
        },
      ],
    },
    {
      id: 497,
      chinese_name: $t("categoryJSON.shou-biao-0"),

      relation_cate_id: 121624001,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.zhi-neng-shou-biao-1"),
          seKeywordTranslation: $t("categoryJSON.sumtowotchi"),
        },
        {
          seKeyword: $t("categoryJSON.dian-hua-shou-biao"),
          seKeywordTranslation: $t("categoryJSON.dian-hua-wan-shi-ji"),
        },
        {
          seKeyword: $t("categoryJSON.ping-guo-shou-biao"),
          seKeywordTranslation: $t("categoryJSON.appuruwotchi"),
        },
        {
          seKeyword: $t("categoryJSON.hua-wei-shou-biao"),
          seKeywordTranslation: $t("categoryJSON.hua-wei-wan-shi-ji"),
        },
        {
          seKeyword: $t("categoryJSON.hua-qiang-bei-shou-biao"),
          seKeywordTranslation: $t("categoryJSON.hua-qiang-bei-wan-shi-ji"),
        },
        {
          seKeyword: $t("categoryJSON.shou-biao-zhi-neng-biao"),
          seKeywordTranslation: $t("categoryJSON.nosumto"),
        },
        {
          seKeyword: $t("categoryJSON.yun-dong-shou-biao"),
          seKeywordTranslation: $t("categoryJSON.suptsuwotchi"),
        },
        {
          seKeyword: $t("categoryJSON.zhi-neng-dian-hua-shou-biao"),
          seKeywordTranslation: $t("categoryJSON.sumtofon"),
        },
        {
          seKeyword: $t(
            "categoryJSON.hua-qiang-bei-s9-ling-dong-dao-shou-biao"
          ),
          seKeywordTranslation: $t(
            "categoryJSON.hua-qiang-bei-s9-ling-dong-dao-wan-shi-ji"
          ),
        },
        {
          seKeyword: $t(
            "categoryJSON.shou-biao-hua-qiang-bei-s9-ling-dong-dao"
          ),
          seKeywordTranslation: $t(
            "categoryJSON.wan-shi-ji-hua-qiang-bei-s9-ling-dong-dao"
          ),
        },
      ],
    },
    {
      id: 498,
      chinese_name: $t("categoryJSON.wen-ju"),

      relation_cate_id: 2111,
      relation_hot_cate: [
        {
          seKeyword: $t("categoryJSON.tie-zhi"),
          seKeywordTranslation: $t("categoryJSON.sutekk"),
        },
        {
          seKeyword: $t("categoryJSON.bi-dai-0"),
          seKeywordTranslation: $t("categoryJSON.penksu"),
        },
        {
          seKeyword: $t("categoryJSON.l-xing-shu-li"),
          seKeywordTranslation: $t("categoryJSON.lbukkuendo"),
        },
        {
          seKeyword: $t("categoryJSON.feng-kou-tie"),
          seKeywordTranslation: $t("categoryJSON.shru"),
        },
        {
          seKeyword: $t("categoryJSON.xiu-zheng-dai"),
          seKeywordTranslation: $t("categoryJSON.tpu"),
        },
        {
          seKeyword: $t("categoryJSON.bi-tong"),
          seKeywordTranslation: $t("categoryJSON.pente"),
        },
        {
          seKeyword: $t("categoryJSON.yi-wu-wen-ju"),
          seKeywordTranslation: $t("categoryJSON.yi-wu-wen-fang-ju"),
        },
        {
          seKeyword: $t("categoryJSON.wen-ju-he"),
          seKeywordTranslation: $t("categoryJSON.ksu-0"),
        },
        {
          seKeyword: $t("categoryJSON.shu-pi"),
          seKeywordTranslation: $t("categoryJSON.bukkukab"),
        },
        {
          seKeyword: $t("categoryJSON.xiang-pi"),
          seKeywordTranslation: $t("categoryJSON.shigomu"),
        },
      ],
    },
  ];
};

export let hotSaleTreeListFn = function () {
  return [
    {
      id: 2,
      parent_id: 1,
      chinese_name: $t("categoryJSON.nv-shi-0"),

      childs: [
        {
          id: 3,
          parent_id: 2,
          chinese_name: $t("categoryJSON.wai-tao-nv-0"),

          childs: [],
        },
        {
          id: 4,
          parent_id: 2,
          chinese_name: $t("categoryJSON.jia-ke-nv-0"),

          childs: [],
        },
        {
          id: 5,
          parent_id: 2,
          chinese_name: $t("categoryJSON.tao-zhuang-nv-0"),

          childs: [],
        },
        {
          id: 6,
          parent_id: 2,
          chinese_name: $t("categoryJSON.t-xu-nv-0"),

          childs: [],
        },
        {
          id: 7,
          parent_id: 2,
          chinese_name: $t("categoryJSON.chen-shan-nv-0"),

          childs: [],
        },
        {
          id: 8,
          parent_id: 2,
          chinese_name: $t("categoryJSON.nv-shi-chen-shan-nv-0"),

          childs: [],
        },
        {
          id: 9,
          parent_id: 2,
          chinese_name: $t("categoryJSON.bei-xin-nv-0"),

          childs: [],
        },
        {
          id: 10,
          parent_id: 2,
          chinese_name: $t("categoryJSON.polo-shan-nv-0"),

          childs: [],
        },
        {
          id: 11,
          parent_id: 2,
          chinese_name: $t("categoryJSON.zhi-fu-nv-0"),

          childs: [],
        },
        {
          id: 12,
          parent_id: 2,
          chinese_name: $t("categoryJSON.kai-jin-shan-nv-0"),

          childs: [],
        },
        {
          id: 13,
          parent_id: 2,
          chinese_name: $t("categoryJSON.mao-yi-nv-0"),

          childs: [],
        },
        {
          id: 14,
          parent_id: 2,
          chinese_name: $t("categoryJSON.lian-yi-qun-nv-0"),

          childs: [],
        },
        {
          id: 15,
          parent_id: 2,
          chinese_name: $t("categoryJSON.duan-qun-nv-0"),

          childs: [],
        },
        {
          id: 16,
          parent_id: 2,
          chinese_name: $t("categoryJSON.niu-zi-ku-nv-0"),

          childs: [],
        },
        {
          id: 17,
          parent_id: 2,
          chinese_name: $t("categoryJSON.ku-zi-nv-0"),

          childs: [],
        },
      ],
    },
    {
      id: 18,
      parent_id: 1,
      chinese_name: $t("categoryJSON.nan-shi-0"),

      childs: [
        {
          id: 19,
          parent_id: 18,
          chinese_name: $t("categoryJSON.wai-tao-nan-0"),

          childs: [],
        },
        {
          id: 20,
          parent_id: 18,
          chinese_name: $t("categoryJSON.jia-ke-nan-0"),

          childs: [],
        },
        {
          id: 21,
          parent_id: 18,
          chinese_name: $t("categoryJSON.tao-zhuang-nan-0"),

          childs: [],
        },
        {
          id: 22,
          parent_id: 18,
          chinese_name: $t("categoryJSON.bei-xin-nan-1"),

          childs: [],
        },
        {
          id: 23,
          parent_id: 18,
          chinese_name: $t("categoryJSON.polo-shan-nan-0"),

          childs: [],
        },
        {
          id: 24,
          parent_id: 18,
          chinese_name: $t("categoryJSON.zhi-fu-nan-0"),

          childs: [],
        },
        {
          id: 25,
          parent_id: 18,
          chinese_name: $t("categoryJSON.chen-shan-nan-0"),

          childs: [],
        },
        {
          id: 26,
          parent_id: 18,
          chinese_name: $t("categoryJSON.t-xu-nan-0"),

          childs: [],
        },
        {
          id: 27,
          parent_id: 18,
          chinese_name: $t("categoryJSON.bei-xin-nan-2"),

          childs: [],
        },
        {
          id: 28,
          parent_id: 18,
          chinese_name: $t("categoryJSON.kai-jin-shan-nan-0"),

          childs: [],
        },
        {
          id: 29,
          parent_id: 18,
          chinese_name: $t("categoryJSON.mao-yi-nan-0"),

          childs: [],
        },
        {
          id: 30,
          parent_id: 18,
          chinese_name: $t("categoryJSON.niu-zi-ku-nan-0"),

          childs: [],
        },
        {
          id: 31,
          parent_id: 18,
          chinese_name: $t("categoryJSON.duan-ku-nan-0"),

          childs: [],
        },
        {
          id: 32,
          parent_id: 18,
          chinese_name: $t("categoryJSON.chang-ku-nan-0"),

          childs: [],
        },
        {
          id: 33,
          parent_id: 18,
          chinese_name: $t("categoryJSON.hei-se-zheng-zhuang-nan-0"),

          childs: [],
        },
      ],
    },
    {
      id: 34,
      parent_id: 1,
      chinese_name: $t("categoryJSON.nei-yi-shi-nei-fu-zhuang-0"),

      childs: [
        {
          id: 35,
          parent_id: 34,
          chinese_name: $t("categoryJSON.nei-chen-0"),

          childs: [],
        },
        {
          id: 36,
          parent_id: 34,
          chinese_name: $t("categoryJSON.jin-shen-ku-1"),

          childs: [],
        },
        {
          id: 37,
          parent_id: 34,
          chinese_name: $t("categoryJSON.nei-ku-0"),

          childs: [],
        },
        {
          id: 38,
          parent_id: 34,
          chinese_name: $t("categoryJSON.quan-ji-shou-0"),

          childs: [],
        },
        {
          id: 39,
          parent_id: 34,
          chinese_name: $t("categoryJSON.wa-zi-0"),

          childs: [],
        },
        {
          id: 40,
          parent_id: 34,
          chinese_name: $t("categoryJSON.yun-dong-wa-0"),

          childs: [],
        },
        {
          id: 41,
          parent_id: 34,
          chinese_name: $t("categoryJSON.shang-wu-wa-0"),

          childs: [],
        },
        {
          id: 42,
          parent_id: 34,
          chinese_name: $t("categoryJSON.shui-yi-0"),

          childs: [],
        },
        {
          id: 43,
          parent_id: 34,
          chinese_name: $t("categoryJSON.nei-bei-xin-0"),

          childs: [],
        },
        {
          id: 44,
          parent_id: 34,
          chinese_name: $t("categoryJSON.duan-ku-1"),

          childs: [],
        },
        {
          id: 46,
          parent_id: 34,
          chinese_name: $t("categoryJSON.tuo-xie-1"),

          childs: [],
        },
        {
          id: 47,
          parent_id: 34,
          chinese_name: $t("categoryJSON.xiong-zhao-0"),

          childs: [],
        },
        {
          id: 48,
          parent_id: 34,
          chinese_name: $t("categoryJSON.yun-dong-wen-xiong-0"),

          childs: [],
        },
        {
          id: 49,
          parent_id: 34,
          chinese_name: $t("categoryJSON.nei-yi-pei-shi-0"),

          childs: [],
        },
      ],
    },
    {
      id: 51,
      parent_id: 50,
      chinese_name: $t("categoryJSON.xie-zi-0"),

      childs: [
        {
          id: 52,
          parent_id: 51,
          chinese_name: $t("categoryJSON.yun-dong-xie-3"),

          childs: [],
        },
        {
          id: 53,
          parent_id: 51,
          chinese_name: $t("categoryJSON.liang-xie-2"),

          childs: [],
        },
        {
          id: 54,
          parent_id: 51,
          chinese_name: $t("categoryJSON.yu-xie-2"),

          childs: [],
        },
        {
          id: 55,
          parent_id: 51,
          chinese_name: $t("categoryJSON.yi-jiao-deng-0"),

          childs: [],
        },
        {
          id: 56,
          parent_id: 51,
          chinese_name: $t("categoryJSON.pi-xie-0"),

          childs: [],
        },
        {
          id: 57,
          parent_id: 51,
          chinese_name: $t("categoryJSON.gong-zuo-xie-0"),

          childs: [],
        },
        {
          id: 58,
          parent_id: 51,
          chinese_name: $t("categoryJSON.tuo-xie-2"),

          childs: [],
        },
        {
          id: 59,
          parent_id: 51,
          chinese_name: $t("categoryJSON.shang-wu-xie-0"),

          childs: [],
        },
        {
          id: 60,
          parent_id: 51,
          chinese_name: $t("categoryJSON.xue-zi-0"),

          childs: [],
        },
      ],
    },
    {
      id: 61,
      parent_id: 50,
      chinese_name: $t("categoryJSON.bei-bao-qian-bao-he-hang-li-xiang-0"),

      childs: [
        {
          id: 62,
          parent_id: 61,
          chinese_name: $t("categoryJSON.shou-ti-bao-0"),

          childs: [],
        },
        {
          id: 63,
          parent_id: 61,
          chinese_name: $t("categoryJSON.dan-jian-bao-0"),

          childs: [],
        },
        {
          id: 64,
          parent_id: 61,
          chinese_name: $t("categoryJSON.pai-dui-bao-0"),

          childs: [],
        },
        {
          id: 65,
          parent_id: 61,
          chinese_name: $t("categoryJSON.bei-bao-0"),

          childs: [],
        },
        {
          id: 66,
          parent_id: 61,
          chinese_name: $t("categoryJSON.shang-wu-bao-0"),

          childs: [],
        },
        {
          id: 67,
          parent_id: 61,
          chinese_name: $t("categoryJSON.xie-kua-bao-0"),

          childs: [],
        },
        {
          id: 68,
          parent_id: 61,
          chinese_name: $t("categoryJSON.qian-bao-0"),

          childs: [],
        },
        {
          id: 69,
          parent_id: 61,
          chinese_name: $t("categoryJSON.ling-qian-bao-0"),

          childs: [],
        },
        {
          id: 70,
          parent_id: 61,
          chinese_name: $t("categoryJSON.qian-jia-zi-0"),

          childs: [],
        },
        {
          id: 71,
          parent_id: 61,
          chinese_name: $t("categoryJSON.ming-pian-jia-0"),

          childs: [],
        },
        {
          id: 72,
          parent_id: 61,
          chinese_name: $t("categoryJSON.yue-chi-bao-0"),

          childs: [],
        },
        {
          id: 73,
          parent_id: 61,
          chinese_name: $t("categoryJSON.shou-ti-xiang-0"),

          childs: [],
        },
      ],
    },
    {
      id: 74,
      parent_id: 50,
      chinese_name: $t("categoryJSON.shi-shang-za-huo-0"),

      childs: [
        {
          id: 75,
          parent_id: 74,
          chinese_name: $t("categoryJSON.yao-dai-0"),

          childs: [],
        },
        {
          id: 76,
          parent_id: 74,
          chinese_name: $t("categoryJSON.mao-zi-4"),

          childs: [],
        },
        {
          id: 77,
          parent_id: 74,
          chinese_name: $t("categoryJSON.shou-tao-1"),

          childs: [],
        },
        {
          id: 78,
          parent_id: 74,
          chinese_name: $t("categoryJSON.san-0"),

          childs: [],
        },
        {
          id: 79,
          parent_id: 74,
          chinese_name: $t("categoryJSON.yang-san-0"),

          childs: [],
        },
        {
          id: 80,
          parent_id: 74,
          chinese_name: $t("categoryJSON.tai-yang-jing-2"),

          childs: [],
        },
        {
          id: 81,
          parent_id: 74,
          chinese_name: $t("categoryJSON.xiu-kou-0"),

          childs: [],
        },
        {
          id: 82,
          parent_id: 74,
          chinese_name: $t("categoryJSON.huan-ling-dai-0"),

          childs: [],
        },
        {
          id: 83,
          parent_id: 74,
          chinese_name: $t("categoryJSON.ling-dai-jia-0"),

          childs: [],
        },
        {
          id: 84,
          parent_id: 74,
          chinese_name: $t("categoryJSON.xiong-zhen-0"),

          childs: [],
        },
        {
          id: 85,
          parent_id: 74,
          chinese_name: $t("categoryJSON.jie-zhi-1"),

          childs: [],
        },
        {
          id: 86,
          parent_id: 74,
          chinese_name: $t("categoryJSON.diao-zhui-0"),

          childs: [],
        },
        {
          id: 87,
          parent_id: 74,
          chinese_name: $t("categoryJSON.er-huan-2"),

          childs: [],
        },
        {
          id: 88,
          parent_id: 74,
          chinese_name: $t("categoryJSON.er-huan-3"),

          childs: [],
        },
        {
          id: 89,
          parent_id: 74,
          chinese_name: $t("categoryJSON.er-tao-0"),

          childs: [],
        },
      ],
    },
    {
      id: 91,
      parent_id: 90,
      chinese_name: $t("categoryJSON.hu-wai-0"),

      childs: [
        {
          id: 92,
          parent_id: 91,
          chinese_name: $t("categoryJSON.zhang-peng-2"),

          childs: [],
        },
        {
          id: 93,
          parent_id: 91,
          chinese_name: $t("categoryJSON.ye-ying-deng-0"),

          childs: [],
        },
        {
          id: 94,
          parent_id: 91,
          chinese_name: $t("categoryJSON.shui-dai-0"),

          childs: [],
        },
        {
          id: 95,
          parent_id: 91,
          chinese_name: $t("categoryJSON.fang-chao-dian-0"),

          childs: [],
        },
        {
          id: 96,
          parent_id: 91,
          chinese_name: $t("categoryJSON.chuan-0"),

          childs: [],
        },
        {
          id: 97,
          parent_id: 91,
          chinese_name: $t("categoryJSON.deng-shan-bao-0"),

          childs: [],
        },
        {
          id: 98,
          parent_id: 91,
          chinese_name: $t("categoryJSON.shou-dian-tong-0"),

          childs: [],
        },
        {
          id: 99,
          parent_id: 91,
          chinese_name: $t("categoryJSON.deng-shan-zhang-0"),

          childs: [],
        },
        {
          id: 100,
          parent_id: 91,
          chinese_name: $t("categoryJSON.peng-ren-yong-pin-0"),

          childs: [],
        },
        {
          id: 101,
          parent_id: 91,
          chinese_name: $t("categoryJSON.shao-kao-0"),

          childs: [],
        },
        {
          id: 102,
          parent_id: 91,
          chinese_name: $t("categoryJSON.leng-cang-xiang-0"),

          childs: [],
        },
        {
          id: 103,
          parent_id: 91,
          chinese_name: $t("categoryJSON.zhuo-zi-2"),

          childs: [],
        },
        {
          id: 104,
          parent_id: 91,
          chinese_name: $t("categoryJSON.diao-chuang-0"),

          childs: [],
        },
        {
          id: 105,
          parent_id: 91,
          chinese_name: $t("categoryJSON.wang-yuan-jing-0"),

          childs: [],
        },
      ],
    },
    {
      id: 106,
      parent_id: 90,
      chinese_name: $t("categoryJSON.yun-dong-fu-he-xie-0"),

      childs: [
        {
          id: 107,
          parent_id: 106,
          chinese_name: $t("categoryJSON.xun-lian-fu-0"),

          childs: [],
        },
        {
          id: 108,
          parent_id: 106,
          chinese_name: $t("categoryJSON.yu-qie-fu-0"),

          childs: [],
        },
        {
          id: 109,
          parent_id: 106,
          chinese_name: $t("categoryJSON.pao-xie-0"),

          childs: [],
        },
        {
          id: 110,
          parent_id: 106,
          chinese_name: $t("categoryJSON.yun-dong-xie-4"),

          childs: [],
        },
        {
          id: 111,
          parent_id: 106,
          chinese_name: $t("categoryJSON.yun-dong-fu-0"),

          childs: [],
        },
        {
          id: 112,
          parent_id: 106,
          chinese_name: $t("categoryJSON.ya-suo-shang-yi-0"),

          childs: [],
        },
        {
          id: 113,
          parent_id: 106,
          chinese_name: $t("categoryJSON.jin-shen-ku-2"),

          childs: [],
        },
        {
          id: 114,
          parent_id: 106,
          chinese_name: $t("categoryJSON.chang-ku-0"),

          childs: [],
        },
        {
          id: 115,
          parent_id: 106,
          chinese_name: $t("categoryJSON.duan-ku-2"),

          childs: [],
        },
        {
          id: 116,
          parent_id: 106,
          chinese_name: $t("categoryJSON.mao-zi-5"),

          childs: [],
        },
      ],
    },
    {
      id: 117,
      parent_id: 90,
      chinese_name: $t("categoryJSON.yong-yi-he-diao-yu-gong-ju-0"),

      childs: [
        {
          id: 118,
          parent_id: 117,
          chinese_name: $t("categoryJSON.bi-ji-ni-1"),

          childs: [],
        },
        {
          id: 119,
          parent_id: 117,
          chinese_name: $t("categoryJSON.lian-ti-yong-yi-0"),

          childs: [],
        },
        {
          id: 120,
          parent_id: 117,
          chinese_name: $t("categoryJSON.er-tong-yong-zhuang-0"),

          childs: [],
        },
        {
          id: 121,
          parent_id: 117,
          chinese_name: $t("categoryJSON.xian-shui-ku-0"),

          childs: [],
        },
        {
          id: 122,
          parent_id: 117,
          chinese_name: $t("categoryJSON.diao-yu-gan-0"),

          childs: [],
        },
        {
          id: 123,
          parent_id: 117,
          chinese_name: $t("categoryJSON.er-0"),

          childs: [],
        },
        {
          id: 124,
          parent_id: 117,
          chinese_name: $t("categoryJSON.gou-zhen-0"),

          childs: [],
        },
        {
          id: 125,
          parent_id: 117,
          chinese_name: $t("categoryJSON.diao-yu-bao-0"),

          childs: [],
        },
        {
          id: 126,
          parent_id: 117,
          chinese_name: $t("categoryJSON.diao-yu-pei-jian-0"),

          childs: [],
        },
        {
          id: 127,
          parent_id: 117,
          chinese_name: $t("categoryJSON.xian-0"),

          childs: [],
        },
        {
          id: 128,
          parent_id: 117,
          chinese_name: $t("categoryJSON.ha-li-si-0"),

          childs: [],
        },
        {
          id: 129,
          parent_id: 117,
          chinese_name: $t("categoryJSON.diao-yu-leng-que-qi-0"),

          childs: [],
        },
      ],
    },
    {
      id: 131,
      parent_id: 130,
      chinese_name: $t("categoryJSON.wan-ju-0"),

      childs: [
        {
          id: 132,
          parent_id: 131,
          chinese_name: $t("categoryJSON.jian-zhu-mo-kuai-0"),

          childs: [],
        },
        {
          id: 133,
          parent_id: 131,
          chinese_name: $t("categoryJSON.wu-xian-dian-kong-zhi-0"),

          childs: [],
        },
        {
          id: 134,
          parent_id: 131,
          chinese_name: $t("categoryJSON.diy-wan-ju-0"),

          childs: [],
        },
        {
          id: 135,
          parent_id: 131,
          chinese_name: $t("categoryJSON.yin-le-wan-ju-0"),

          childs: [],
        },
        {
          id: 136,
          parent_id: 131,
          chinese_name: $t("categoryJSON.hu-wai-wan-ju-0"),

          childs: [],
        },
        {
          id: 137,
          parent_id: 131,
          chinese_name: $t("categoryJSON.yi-zhi-wan-ju-0"),

          childs: [],
        },
        {
          id: 138,
          parent_id: 131,
          chinese_name: $t("categoryJSON.ying-er-wan-ju-0"),

          childs: [],
        },
        {
          id: 139,
          parent_id: 131,
          chinese_name: $t("categoryJSON.shu-zi-0"),

          childs: [],
        },
        {
          id: 140,
          parent_id: 131,
          chinese_name: $t("categoryJSON.su-liao-mo-xing-0"),

          childs: [],
        },
        {
          id: 141,
          parent_id: 131,
          chinese_name: $t("categoryJSON.mao-rong-gong-zi-0"),

          childs: [],
        },
        {
          id: 142,
          parent_id: 131,
          chinese_name: $t("categoryJSON.zhuo-shang-you-xi-0"),

          childs: [],
        },
        {
          id: 143,
          parent_id: 131,
          chinese_name: $t("categoryJSON.qi-0"),

          childs: [],
        },
        {
          id: 144,
          parent_id: 131,
          chinese_name: $t("categoryJSON.hei-bai-qi-0"),

          childs: [],
        },
        {
          id: 145,
          parent_id: 131,
          chinese_name: $t("categoryJSON.qu-0"),

          childs: [],
        },
      ],
    },
    {
      id: 146,
      parent_id: 130,
      chinese_name: $t("categoryJSON.nv-hai-0"),

      childs: [
        {
          id: 147,
          parent_id: 146,
          chinese_name: $t("categoryJSON.jia-ke-2"),

          childs: [],
        },
        {
          id: 148,
          parent_id: 146,
          chinese_name: $t("categoryJSON.qun-zi-1"),

          childs: [],
        },
        {
          id: 149,
          parent_id: 146,
          chinese_name: $t("categoryJSON.pai-ke-1"),

          childs: [],
        },
        {
          id: 150,
          parent_id: 146,
          chinese_name: $t("categoryJSON.ban-ku-1"),

          childs: [],
        },
        {
          id: 151,
          parent_id: 146,
          chinese_name: $t("categoryJSON.yu-yi-2"),

          childs: [],
        },
        {
          id: 152,
          parent_id: 146,
          chinese_name: $t("categoryJSON.mao-zi-6"),

          childs: [],
        },
        {
          id: 153,
          parent_id: 146,
          chinese_name: $t("categoryJSON.tai-yang-jing-3"),

          childs: [],
        },
        {
          id: 154,
          parent_id: 146,
          chinese_name: $t("categoryJSON.yun-dong-xie-5"),

          childs: [],
        },
        {
          id: 155,
          parent_id: 146,
          chinese_name: $t("categoryJSON.liang-xie-3"),

          childs: [],
        },
        {
          id: 156,
          parent_id: 146,
          chinese_name: $t("categoryJSON.yu-xie-3"),

          childs: [],
        },
      ],
    },
    {
      id: 157,
      parent_id: 130,
      chinese_name: $t("categoryJSON.nan-hai-er-men-0"),

      childs: [
        {
          id: 158,
          parent_id: 157,
          chinese_name: $t("categoryJSON.wai-tao-0"),

          childs: [],
        },
        {
          id: 159,
          parent_id: 157,
          chinese_name: $t("categoryJSON.jia-ke-3"),

          childs: [],
        },
        {
          id: 160,
          parent_id: 157,
          chinese_name: $t("categoryJSON.zheng-shi-de-0"),

          childs: [],
        },
        {
          id: 161,
          parent_id: 157,
          chinese_name: $t("categoryJSON.pai-ke-2"),

          childs: [],
        },
        {
          id: 162,
          parent_id: 157,
          chinese_name: $t("categoryJSON.ban-ku-2"),

          childs: [],
        },
        {
          id: 163,
          parent_id: 157,
          chinese_name: $t("categoryJSON.yu-yi-3"),

          childs: [],
        },
        {
          id: 164,
          parent_id: 157,
          chinese_name: $t("categoryJSON.mao-zi-7"),

          childs: [],
        },
        {
          id: 165,
          parent_id: 157,
          chinese_name: $t("categoryJSON.tai-yang-jing-4"),

          childs: [],
        },
        {
          id: 166,
          parent_id: 157,
          chinese_name: $t("categoryJSON.yun-dong-xie-6"),

          childs: [],
        },
        {
          id: 167,
          parent_id: 157,
          chinese_name: $t("categoryJSON.liang-xie-4"),

          childs: [],
        },
        {
          id: 168,
          parent_id: 157,
          chinese_name: $t("categoryJSON.yu-xie-4"),

          childs: [],
        },
      ],
    },
    {
      id: 170,
      parent_id: 169,
      chinese_name: $t("categoryJSON.mao-yong-pin-0"),

      childs: [
        {
          id: 171,
          parent_id: 170,
          chinese_name: $t("categoryJSON.chuang-1"),

          childs: [],
        },
        {
          id: 172,
          parent_id: 170,
          chinese_name: $t("categoryJSON.can-ju-wan-0"),

          childs: [],
        },
        {
          id: 173,
          parent_id: 170,
          chinese_name: $t("categoryJSON.zi-dong-song-liao-qi-1"),

          childs: [],
        },
        {
          id: 174,
          parent_id: 170,
          chinese_name: $t("categoryJSON.chuang-sha-fa-0"),

          childs: [],
        },
        {
          id: 175,
          parent_id: 170,
          chinese_name: $t("categoryJSON.ti-long-0"),

          childs: [],
        },
        {
          id: 176,
          parent_id: 170,
          chinese_name: $t("categoryJSON.mao-ta-0"),

          childs: [],
        },
        {
          id: 177,
          parent_id: 170,
          chinese_name: $t("categoryJSON.xiang-quan-1"),

          childs: [],
        },
        {
          id: 179,
          parent_id: 170,
          chinese_name: $t("categoryJSON.mao-sha-pen-0"),

          childs: [],
        },
        {
          id: 180,
          parent_id: 170,
          chinese_name: $t("categoryJSON.yao-0"),

          childs: [],
        },
        {
          id: 181,
          parent_id: 170,
          chinese_name: $t("categoryJSON.qiu-1"),

          childs: [],
        },
        {
          id: 182,
          parent_id: 170,
          chinese_name: $t("categoryJSON.lao-shu-mao-rong-wan-ju-0"),

          childs: [],
        },
      ],
    },
    {
      id: 183,
      parent_id: 169,
      chinese_name: $t("categoryJSON.quan-yong-pin-0"),

      childs: [
        {
          id: 184,
          parent_id: 183,
          chinese_name: $t("categoryJSON.can-ju-yu-er-jia-0"),

          childs: [],
        },
        {
          id: 185,
          parent_id: 183,
          chinese_name: $t("categoryJSON.zi-dong-song-liao-qi-2"),

          childs: [],
        },
        {
          id: 186,
          parent_id: 183,
          chinese_name: $t("categoryJSON.die-jia-0"),

          childs: [],
        },
        {
          id: 187,
          parent_id: 183,
          chinese_name: $t("categoryJSON.shui-rong-qi-shui-ping-0"),

          childs: [],
        },
        {
          id: 188,
          parent_id: 183,
          chinese_name: $t("categoryJSON.shua-zi-0"),

          childs: [],
        },
        {
          id: 189,
          parent_id: 183,
          chinese_name: $t("categoryJSON.mu-yu-yong-pin-0"),

          childs: [],
        },
        {
          id: 190,
          parent_id: 183,
          chinese_name: $t("categoryJSON.xiang-quan-2"),

          childs: [],
        },
        {
          id: 191,
          parent_id: 183,
          chinese_name: $t("categoryJSON.qian-gou-sheng-0"),

          childs: [],
        },
        {
          id: 192,
          parent_id: 183,
          chinese_name: $t("categoryJSON.xie-dai-rong-qi-0"),

          childs: [],
        },
        {
          id: 193,
          parent_id: 183,
          chinese_name: $t("categoryJSON.long-0"),

          childs: [],
        },
        {
          id: 194,
          parent_id: 183,
          chinese_name: $t("categoryJSON.gou-wo-0"),

          childs: [],
        },
        {
          id: 195,
          parent_id: 183,
          chinese_name: $t("categoryJSON.chuang-dian-2"),

          childs: [],
        },
        {
          id: 196,
          parent_id: 183,
          chinese_name: $t("categoryJSON.qiu-2"),

          childs: [],
        },
        {
          id: 197,
          parent_id: 183,
          chinese_name: $t("categoryJSON.tou-zhi-wan-ju-0"),

          childs: [],
        },
        {
          id: 198,
          parent_id: 183,
          chinese_name: $t("categoryJSON.fu-zhuang-yu-shi-pin-0"),

          childs: [],
        },
      ],
    },
    {
      id: 200,
      parent_id: 199,
      chinese_name: $t("categoryJSON.shou-na-yong-pin-0"),

      childs: [
        {
          id: 201,
          parent_id: 200,
          chinese_name: $t("categoryJSON.lan-zi-0"),

          childs: [],
        },
        {
          id: 202,
          parent_id: 200,
          chinese_name: $t("categoryJSON.ya-suo-dai-0"),

          childs: [],
        },
        {
          id: 203,
          parent_id: 200,
          chinese_name: $t("categoryJSON.za-zhi-jia-0"),

          childs: [],
        },
        {
          id: 204,
          parent_id: 200,
          chinese_name: $t("categoryJSON.yao-kong-jia-0"),

          childs: [],
        },
        {
          id: 205,
          parent_id: 200,
          chinese_name: $t("categoryJSON.gou-0"),

          childs: [],
        },
        {
          id: 206,
          parent_id: 200,
          chinese_name: $t("categoryJSON.chu-wu-dai-0"),

          childs: [],
        },
        {
          id: 207,
          parent_id: 200,
          chinese_name: $t("categoryJSON.bi-dai-1"),

          childs: [],
        },
      ],
    },
    {
      id: 209,
      parent_id: 199,
      chinese_name: $t("categoryJSON.za-huo-0"),

      childs: [
        {
          id: 210,
          parent_id: 209,
          chinese_name: $t("categoryJSON.gua-zhong-0"),

          childs: [],
        },
        {
          id: 211,
          parent_id: 209,
          chinese_name: $t("categoryJSON.la-ji-tong-0"),

          childs: [],
        },
        {
          id: 212,
          parent_id: 209,
          chinese_name: $t("categoryJSON.qiang-tie-0"),

          childs: [],
        },
        {
          id: 213,
          parent_id: 209,
          chinese_name: $t("categoryJSON.xie-ba-zi-0"),

          childs: [],
        },
        {
          id: 214,
          parent_id: 209,
          chinese_name: $t("categoryJSON.zhi-men-qi-0"),

          childs: [],
        },
        {
          id: 215,
          parent_id: 209,
          chinese_name: $t("categoryJSON.zhu-tai-0"),

          childs: [],
        },
        {
          id: 216,
          parent_id: 209,
          chinese_name: $t("categoryJSON.yan-hui-gang-1"),

          childs: [],
        },
        {
          id: 217,
          parent_id: 209,
          chinese_name: $t("categoryJSON.feng-shui-wu-pin-0"),

          childs: [],
        },
        {
          id: 218,
          parent_id: 209,
          chinese_name: $t("categoryJSON.chuang-mo-0"),

          childs: [],
        },
        {
          id: 219,
          parent_id: 209,
          chinese_name: $t("categoryJSON.bian-li-pin-0"),

          childs: [],
        },
      ],
    },
    {
      id: 221,
      parent_id: 220,
      chinese_name: $t("categoryJSON.ban-gong-yong-pin-1"),

      childs: [
        {
          id: 222,
          parent_id: 221,
          chinese_name: $t("categoryJSON.dao-ju-0"),

          childs: [],
        },
        {
          id: 223,
          parent_id: 221,
          chinese_name: $t("categoryJSON.jian-dao-0"),

          childs: [],
        },
        {
          id: 224,
          parent_id: 221,
          chinese_name: $t("categoryJSON.jiao-shui-0"),

          childs: [],
        },
        {
          id: 225,
          parent_id: 221,
          chinese_name: $t("categoryJSON.ding-shu-ji-0"),

          childs: [],
        },
        {
          id: 226,
          parent_id: 221,
          chinese_name: $t("categoryJSON.jiao-dai-0"),

          childs: [],
        },
        {
          id: 227,
          parent_id: 221,
          chinese_name: $t("categoryJSON.jia-zi-0"),

          childs: [],
        },
        {
          id: 228,
          parent_id: 221,
          chinese_name: $t("categoryJSON.zheng-jian-pai-0"),

          childs: [],
        },
        {
          id: 229,
          parent_id: 221,
          chinese_name: $t("categoryJSON.zheng-shu-kuang-0"),

          childs: [],
        },
        {
          id: 230,
          parent_id: 221,
          chinese_name: $t("categoryJSON.wen-jian-jia-0"),

          childs: [],
        },
        {
          id: 231,
          parent_id: 221,
          chinese_name: $t("categoryJSON.yuan-zhu-bi-0"),

          childs: [],
        },
        {
          id: 232,
          parent_id: 221,
          chinese_name: $t("categoryJSON.gang-bi-0"),

          childs: [],
        },
        {
          id: 233,
          parent_id: 221,
          chinese_name: $t("categoryJSON.bai-ban-0"),

          childs: [],
        },
      ],
    },
    {
      id: 234,
      parent_id: 220,
      chinese_name: $t("categoryJSON.ban-gong-yong-zhi-0"),

      childs: [
        {
          id: 235,
          parent_id: 234,
          chinese_name: $t("categoryJSON.fu-yin-zhi-0"),

          childs: [],
        },
        {
          id: 236,
          parent_id: 234,
          chinese_name: $t("categoryJSON.ji-guang-da-yin-zhi-0"),

          childs: [],
        },
        {
          id: 237,
          parent_id: 234,
          chinese_name: $t("categoryJSON.yin-shua-yong-cai-zhi-0"),

          childs: [],
        },
        {
          id: 238,
          parent_id: 234,
          chinese_name: $t("categoryJSON.hui-tu-zhi-0"),

          childs: [],
        },
        {
          id: 239,
          parent_id: 234,
          chinese_name: $t("categoryJSON.xin-0"),

          childs: [],
        },
        {
          id: 240,
          parent_id: 234,
          chinese_name: $t("categoryJSON.bian-li-tie-0"),

          childs: [],
        },
        {
          id: 241,
          parent_id: 234,
          chinese_name: $t("categoryJSON.huo-ye-0"),

          childs: [],
        },
        {
          id: 242,
          parent_id: 234,
          chinese_name: $t("categoryJSON.ji-shi-ben-0"),

          childs: [],
        },
      ],
    },
    {
      id: 244,
      parent_id: 243,
      chinese_name: $t("categoryJSON.qi-che-pei-jian-0"),

      childs: [
        {
          id: 245,
          parent_id: 244,
          chinese_name: $t("categoryJSON.hang-che-ji-lu-yi-0"),

          childs: [],
        },
        {
          id: 246,
          parent_id: 244,
          chinese_name: $t("categoryJSON.hou-zhi-she-xiang-tou-ji-shen-0"),

          childs: [],
        },
        {
          id: 250,
          parent_id: 244,
          chinese_name: $t("categoryJSON.zuo-tao-1"),

          childs: [],
        },
        {
          id: 251,
          parent_id: 244,
          chinese_name: $t("categoryJSON.zuo-dian-0"),

          childs: [],
        },
        {
          id: 252,
          parent_id: 244,
          chinese_name: $t("categoryJSON.tie-zhi-tie-hua-yin-zhang-0"),

          childs: [],
        },
        {
          id: 253,
          parent_id: 244,
          chinese_name: $t("categoryJSON.fang-xiang-pan-tao-0"),

          childs: [],
        },
        {
          id: 254,
          parent_id: 244,
          chinese_name: $t("categoryJSON.kong-qi-jing-hua-qi-1"),

          childs: [],
        },
        {
          id: 255,
          parent_id: 244,
          chinese_name: $t("categoryJSON.yan-hui-gang-2"),

          childs: [],
        },
        {
          id: 256,
          parent_id: 244,
          chinese_name: $t("categoryJSON.an-quan-dai-yong-pin-0"),

          childs: [],
        },
        {
          id: 257,
          parent_id: 244,
          chinese_name: $t("categoryJSON.ying-er-er-tong-zuo-yi-0"),

          childs: [],
        },
        {
          id: 258,
          parent_id: 244,
          chinese_name: $t("categoryJSON.kong-tiao-lv-qing-qi-0"),

          childs: [],
        },
      ],
    },
    {
      id: 259,
      parent_id: 243,
      chinese_name: $t("categoryJSON.qi-che-yong-pin-0"),

      childs: [
        {
          id: 260,
          parent_id: 259,
          chinese_name: $t("categoryJSON.che-deng-0"),

          childs: [],
        },
        {
          id: 261,
          parent_id: 259,
          chinese_name: $t("categoryJSON.cha-che-ling-jian-0"),

          childs: [],
        },
        {
          id: 262,
          parent_id: 259,
          chinese_name: $t("categoryJSON.wai-shi-he-hang-kong-bu-jian-0"),

          childs: [],
        },
        {
          id: 263,
          parent_id: 259,
          chinese_name: $t("categoryJSON.jia-qiang-jian-0"),

          childs: [],
        },
        {
          id: 264,
          parent_id: 259,
          chinese_name: $t("categoryJSON.bao-yang-pin-0"),

          childs: [],
        },
        {
          id: 265,
          parent_id: 259,
          chinese_name: $t("categoryJSON.qi-che-wei-xiu-gong-ju-0"),

          childs: [],
        },
        {
          id: 266,
          parent_id: 259,
          chinese_name: $t("categoryJSON.kong-tiao-wei-xiu-0"),

          childs: [],
        },
        {
          id: 267,
          parent_id: 259,
          chinese_name: $t("categoryJSON.che-ku-yong-pin-0"),

          childs: [],
        },
        {
          id: 268,
          parent_id: 259,
          chinese_name: $t("categoryJSON.wu-ding-zai-ti-0"),

          childs: [],
        },
        {
          id: 269,
          parent_id: 259,
          chinese_name: $t("categoryJSON.hou-zhi-zai-ti-0"),

          childs: [],
        },
        {
          id: 270,
          parent_id: 259,
          chinese_name: $t("categoryJSON.lun-tai-jia-gai-0"),

          childs: [],
        },
      ],
    },
    {
      id: 271,
      parent_id: 243,
      chinese_name: $t("categoryJSON.zi-hang-che-yong-pin-0"),

      childs: [
        {
          id: 272,
          parent_id: 271,
          chinese_name: $t("categoryJSON.zheng-ge-lian-0"),

          childs: [],
        },
        {
          id: 273,
          parent_id: 271,
          chinese_name: $t("categoryJSON.yi-ban-0"),

          childs: [],
        },
        {
          id: 274,
          parent_id: 271,
          chinese_name: $t("categoryJSON.jia-ke-4"),

          childs: [],
        },
        {
          id: 275,
          parent_id: 271,
          chinese_name: $t("categoryJSON.shou-tao-2"),

          childs: [],
        },
        {
          id: 276,
          parent_id: 271,
          chinese_name: $t("categoryJSON.xue-tao-0"),

          childs: [],
        },
        {
          id: 277,
          parent_id: 271,
          chinese_name: $t("categoryJSON.yu-yi-4"),

          childs: [],
        },
        {
          id: 278,
          parent_id: 271,
          chinese_name: $t("categoryJSON.bao-hu-zhe-0"),

          childs: [],
        },
        {
          id: 279,
          parent_id: 271,
          chinese_name: $t("categoryJSON.sai-che-fu-0"),

          childs: [],
        },
        {
          id: 280,
          parent_id: 271,
          chinese_name: $t("categoryJSON.yan-jing-0"),

          childs: [],
        },
        {
          id: 281,
          parent_id: 271,
          chinese_name: $t("categoryJSON.yin-liao-jia-0"),

          childs: [],
        },
        {
          id: 282,
          parent_id: 271,
          chinese_name: $t("categoryJSON.tou-kui-suo-0"),

          childs: [],
        },
        {
          id: 283,
          parent_id: 271,
          chinese_name: $t("categoryJSON.zi-hang-che-suo-0"),

          childs: [],
        },
        {
          id: 284,
          parent_id: 271,
          chinese_name: $t("categoryJSON.che-shen-zhao-0"),

          childs: [],
        },
        {
          id: 285,
          parent_id: 271,
          chinese_name: $t("categoryJSON.zuo-tao-2"),

          childs: [],
        },
        {
          id: 286,
          parent_id: 271,
          chinese_name: $t("categoryJSON.mo-tuo-che-tie-zhi-he-tie-hua-0"),

          childs: [],
        },
      ],
    },
    {
      id: 288,
      parent_id: 287,
      chinese_name: $t("categoryJSON.jia-ju-0"),

      childs: [
        {
          id: 289,
          parent_id: 288,
          chinese_name: $t("categoryJSON.zhuo-zi-3"),

          childs: [],
        },
        {
          id: 290,
          parent_id: 288,
          chinese_name: $t("categoryJSON.can-ju-0"),

          childs: [],
        },
        {
          id: 291,
          parent_id: 288,
          chinese_name: $t("categoryJSON.zhuo-zi-4"),

          childs: [],
        },
        {
          id: 292,
          parent_id: 288,
          chinese_name: $t("categoryJSON.zuo-yi-zi-0"),

          childs: [],
        },
        {
          id: 293,
          parent_id: 288,
          chinese_name: $t("categoryJSON.yi-zi-0"),

          childs: [],
        },
        {
          id: 294,
          parent_id: 288,
          chinese_name: $t("categoryJSON.sha-fa-0"),

          childs: [],
        },
        {
          id: 295,
          parent_id: 288,
          chinese_name: $t("categoryJSON.jiao-deng-0"),

          childs: [],
        },
        {
          id: 296,
          parent_id: 288,
          chinese_name: $t("categoryJSON.sha-fa-chuang-0"),

          childs: [],
        },
        {
          id: 297,
          parent_id: 288,
          chinese_name: $t("categoryJSON.chuang-2"),

          childs: [],
        },
        {
          id: 298,
          parent_id: 288,
          chinese_name: $t("categoryJSON.chuang-tou-gui-0"),

          childs: [],
        },
        {
          id: 299,
          parent_id: 288,
          chinese_name: $t("categoryJSON.chuang-wei-shi-0"),

          childs: [],
        },
        {
          id: 300,
          parent_id: 288,
          chinese_name: $t("categoryJSON.shu-zhuang-tai-shu-zhuang-tai-0"),

          childs: [],
        },
        {
          id: 301,
          parent_id: 288,
          chinese_name: $t("categoryJSON.fen-qu-ping-mu-0"),

          childs: [],
        },
      ],
    },
    {
      id: 302,
      parent_id: 287,
      chinese_name: $t("categoryJSON.qin-shi-yong-pin-0"),

      childs: [
        {
          id: 303,
          parent_id: 302,
          chinese_name: $t("categoryJSON.zhen-tou-bao-zhen-0"),

          childs: [],
        },
        {
          id: 304,
          parent_id: 302,
          chinese_name: $t("categoryJSON.bei-tao-0"),

          childs: [],
        },
        {
          id: 305,
          parent_id: 302,
          chinese_name: $t("categoryJSON.chuang-dian-3"),

          childs: [],
        },
        {
          id: 306,
          parent_id: 302,
          chinese_name: $t("categoryJSON.chuang-dian-4"),

          childs: [],
        },
        {
          id: 307,
          parent_id: 302,
          chinese_name: $t("categoryJSON.bei-ru-0"),

          childs: [],
        },
        {
          id: 308,
          parent_id: 302,
          chinese_name: $t("categoryJSON.mian-bei-0"),

          childs: [],
        },
        {
          id: 309,
          parent_id: 302,
          chinese_name: $t("categoryJSON.chuang-shang-yong-pin-chuang-dan-0"),

          childs: [],
        },
        {
          id: 310,
          parent_id: 302,
          chinese_name: $t("categoryJSON.tan-zi-0"),

          childs: [],
        },
        {
          id: 311,
          parent_id: 302,
          chinese_name: $t("categoryJSON.tan-zi-he-juan-tong-chuan-0"),

          childs: [],
        },
        {
          id: 312,
          parent_id: 302,
          chinese_name: $t("categoryJSON.gai-tan-ban-tan-0"),

          childs: [],
        },
        {
          id: 313,
          parent_id: 302,
          chinese_name: $t("categoryJSON.mao-jin-tan-sha-tan-0"),

          childs: [],
        },
      ],
    },
    {
      id: 315,
      parent_id: 314,
      chinese_name: $t("categoryJSON.she-xiang-tou-1"),

      childs: [
        {
          id: 316,
          parent_id: 315,
          chinese_name: $t("categoryJSON.wai-jie-ying-pan-0"),

          childs: [],
        },
        {
          id: 317,
          parent_id: 315,
          chinese_name: $t("categoryJSON.usb-cun-chu-qi-shan-cun-qu-dong-qi-0"),

          childs: [],
        },
        {
          id: 318,
          parent_id: 315,
          chinese_name: $t("categoryJSON.wai-bu-du-ka-qi-0"),

          childs: [],
        },
        {
          id: 319,
          parent_id: 315,
          chinese_name: $t("categoryJSON.tou-ying-yi-0"),

          childs: [],
        },
        {
          id: 320,
          parent_id: 315,
          chinese_name: $t("categoryJSON.zhuan-huan-shi-pei-qi-0"),

          childs: [],
        },
        {
          id: 321,
          parent_id: 315,
          chinese_name: $t("categoryJSON.dian-lan-1"),

          childs: [],
        },
        {
          id: 322,
          parent_id: 315,
          chinese_name: $t("categoryJSON.kai-guan-ji-0"),

          childs: [],
        },
        {
          id: 323,
          parent_id: 315,
          chinese_name: $t("categoryJSON.pc-bao-tao-0"),

          childs: [],
        },
        {
          id: 324,
          parent_id: 315,
          chinese_name: $t("categoryJSON.cun-chu-ka-0"),

          childs: [],
        },
        {
          id: 325,
          parent_id: 315,
          chinese_name: $t("categoryJSON.you-xi-jian-pan-0"),

          childs: [],
        },
        {
          id: 326,
          parent_id: 315,
          chinese_name: $t("categoryJSON.jian-pan-0"),

          childs: [],
        },
        {
          id: 327,
          parent_id: 315,
          chinese_name: $t("categoryJSON.shu-0"),

          childs: [],
        },
        {
          id: 328,
          parent_id: 315,
          chinese_name: $t("categoryJSON.you-xi-shu-biao-0"),

          childs: [],
        },
        {
          id: 329,
          parent_id: 315,
          chinese_name: $t("categoryJSON.you-xi-shou-bing-0"),

          childs: [],
        },
        {
          id: 330,
          parent_id: 315,
          chinese_name: $t("categoryJSON.she-xiang-tou-2"),

          childs: [],
        },
      ],
    },
    {
      id: 331,
      parent_id: 314,
      chinese_name: $t("categoryJSON.zhi-neng-shou-biao-2"),

      childs: [
        {
          id: 332,
          parent_id: 331,
          chinese_name: $t("categoryJSON.yi-dong-shen-ti-0"),

          childs: [],
        },
        {
          id: 333,
          parent_id: 331,
          chinese_name: $t("categoryJSON.an-zi-0"),

          childs: [],
        },
        {
          id: 334,
          parent_id: 331,
          chinese_name: $t("categoryJSON.fu-gai-0"),

          childs: [],
        },
        {
          id: 335,
          parent_id: 331,
          chinese_name: $t("categoryJSON.dian-chi-0"),

          childs: [],
        },
        {
          id: 336,
          parent_id: 331,
          chinese_name: $t("categoryJSON.dian-lan-2"),

          childs: [],
        },
        {
          id: 337,
          parent_id: 331,
          chinese_name: $t("categoryJSON.zhan-li-0"),

          childs: [],
        },
        {
          id: 338,
          parent_id: 331,
          chinese_name: $t("categoryJSON.ye-jing-bao-hu-mo-0"),

          childs: [],
        },
        {
          id: 339,
          parent_id: 331,
          chinese_name: $t("categoryJSON.er-ji-lan-ya-0"),

          childs: [],
        },
        {
          id: 340,
          parent_id: 331,
          chinese_name: $t("categoryJSON.er-ji-2"),

          childs: [],
        },
        {
          id: 341,
          parent_id: 331,
          chinese_name: $t("categoryJSON.zi-pai-gan-0"),

          childs: [],
        },
        {
          id: 342,
          parent_id: 331,
          chinese_name: $t("categoryJSON.zhi-neng-shou-biao-3"),

          childs: [],
        },
      ],
    },
    {
      id: 343,
      parent_id: 314,
      chinese_name: $t("categoryJSON.jian-kong-she-xiang-tou-1"),

      childs: [
        {
          id: 344,
          parent_id: 343,
          chinese_name: $t("categoryJSON.kong-qi-jing-hua-qi-2"),

          childs: [],
        },
        {
          id: 345,
          parent_id: 343,
          chinese_name: $t("categoryJSON.chu-shi-ji-0"),

          childs: [],
        },
        {
          id: 346,
          parent_id: 343,
          chinese_name: $t("categoryJSON.jia-shi-qi-0"),

          childs: [],
        },
        {
          id: 347,
          parent_id: 343,
          chinese_name: $t("categoryJSON.re-di-tan-0"),

          childs: [],
        },
        {
          id: 348,
          parent_id: 343,
          chinese_name: $t("categoryJSON.zhi-jia-hong-gan-ji-0"),

          childs: [],
        },
        {
          id: 349,
          parent_id: 343,
          chinese_name: $t("categoryJSON.an-mo-yi-1"),

          childs: [],
        },
        {
          id: 350,
          parent_id: 343,
          chinese_name: $t("categoryJSON.an-mo-yi-2"),

          childs: [],
        },
        {
          id: 351,
          parent_id: 343,
          chinese_name: $t("categoryJSON.bing-xiang-0"),

          childs: [],
        },
        {
          id: 352,
          parent_id: 343,
          chinese_name: $t("categoryJSON.jia-ting-ying-yuan-xi-tong-0"),

          childs: [],
        },
        {
          id: 353,
          parent_id: 343,
          chinese_name: $t("categoryJSON.wu-ren-ji-0"),

          childs: [],
        },
        {
          id: 354,
          parent_id: 343,
          chinese_name: $t("categoryJSON.yang-sheng-qi-0"),

          childs: [],
        },
        {
          id: 355,
          parent_id: 343,
          chinese_name: $t("categoryJSON.jian-kong-she-xiang-tou-2"),

          childs: [],
        },
      ],
    },
    {
      id: 357,
      parent_id: 356,
      chinese_name: $t("categoryJSON.led-ri-guang-deng-1"),

      childs: [
        {
          id: 358,
          parent_id: 357,
          chinese_name: $t("categoryJSON.la-di-deng-0"),

          childs: [],
        },
        {
          id: 359,
          parent_id: 357,
          chinese_name: $t("categoryJSON.tai-deng-0"),

          childs: [],
        },
        {
          id: 360,
          parent_id: 357,
          chinese_name: $t("categoryJSON.zhao-ming-deng-0"),

          childs: [],
        },
        {
          id: 361,
          parent_id: 357,
          chinese_name: $t("categoryJSON.xiang-xun-deng-0"),

          childs: [],
        },
        {
          id: 362,
          parent_id: 357,
          chinese_name: $t("categoryJSON.zhu-guang-0"),

          childs: [],
        },
        {
          id: 363,
          parent_id: 357,
          chinese_name: $t("categoryJSON.deng-zhao-0"),

          childs: [],
        },
        {
          id: 364,
          parent_id: 357,
          chinese_name: $t("categoryJSON.ju-guang-deng-0"),

          childs: [],
        },
        {
          id: 365,
          parent_id: 357,
          chinese_name: $t("categoryJSON.guan-dao-dao-gui-deng-0"),

          childs: [],
        },
        {
          id: 366,
          parent_id: 357,
          chinese_name: $t("categoryJSON.gan-ying-deng-0"),

          childs: [],
        },
        {
          id: 367,
          parent_id: 357,
          chinese_name: $t("categoryJSON.ting-yuan-deng-0"),

          childs: [],
        },
        {
          id: 368,
          parent_id: 357,
          chinese_name: $t("categoryJSON.lan-0"),

          childs: [],
        },
        {
          id: 369,
          parent_id: 357,
          chinese_name: $t("categoryJSON.led-deng-pao-0"),

          childs: [],
        },
        {
          id: 370,
          parent_id: 357,
          chinese_name: $t("categoryJSON.led-ri-guang-deng-2"),

          childs: [],
        },
      ],
    },
    {
      id: 372,
      parent_id: 371,
      chinese_name: $t("categoryJSON.yan-mo-gong-ju-1"),

      childs: [
        {
          id: 373,
          parent_id: 372,
          chinese_name: $t("categoryJSON.dian-dong-gong-ju-0"),

          childs: [],
        },
        {
          id: 374,
          parent_id: 372,
          chinese_name: $t("categoryJSON.shou-dong-gong-ju-0"),

          childs: [],
        },
        {
          id: 375,
          parent_id: 372,
          chinese_name: $t("categoryJSON.qi-dong-gong-ju-0"),

          childs: [],
        },
        {
          id: 376,
          parent_id: 372,
          chinese_name: $t("categoryJSON.yan-mo-gong-ju-2"),

          childs: [],
        },
      ],
    },
    {
      id: 377,
      parent_id: 371,
      chinese_name: $t("categoryJSON.xin-hao-deng-1"),

      childs: [
        {
          id: 378,
          parent_id: 377,
          chinese_name: $t("categoryJSON.lao-bao-xie-0"),

          childs: [],
        },
        {
          id: 379,
          parent_id: 377,
          chinese_name: $t("categoryJSON.ye-zhan-tou-kui-0"),

          childs: [],
        },
        {
          id: 380,
          parent_id: 377,
          chinese_name: $t("categoryJSON.ge-yin-0"),

          childs: [],
        },
        {
          id: 381,
          parent_id: 377,
          chinese_name: $t("categoryJSON.an-quan-dai-0"),

          childs: [],
        },
        {
          id: 382,
          parent_id: 377,
          chinese_name: $t("categoryJSON.gong-zuo-hu-mu-jing-0"),

          childs: [],
        },
        {
          id: 383,
          parent_id: 377,
          chinese_name: $t("categoryJSON.gong-zuo-shou-tao-0"),

          childs: [],
        },
        {
          id: 384,
          parent_id: 377,
          chinese_name: $t("categoryJSON.gong-zuo-mian-ju-0"),

          childs: [],
        },
        {
          id: 385,
          parent_id: 377,
          chinese_name: $t("categoryJSON.gong-zuo-fu-0"),

          childs: [],
        },
        {
          id: 386,
          parent_id: 377,
          chinese_name: $t("categoryJSON.an-quan-biao-shi-0"),

          childs: [],
        },
        {
          id: 387,
          parent_id: 377,
          chinese_name: $t("categoryJSON.se-zhui-0"),

          childs: [],
        },
        {
          id: 388,
          parent_id: 377,
          chinese_name: $t("categoryJSON.xin-hao-deng-2"),

          childs: [],
        },
      ],
    },
  ];
};
